import async from "../components/Async";
import {
  faHome,
  faMapMarkerAlt,
  faMoneyBill,
  faTable,
  faUserCircle,
  faClock,
  faIdCard,
  faSignInAlt,
  faImages,
  faList,
  faVolumeUp,
  faUserTie,
  faUserPlus,
  faUserFriends,
  faLandmark,
  faFolderOpen,
  faUserSlash,
  faMobile,
  faCommentAlt,
  faExclamationTriangle,
  faProjectDiagram,
  faBook,
  faAward,
  faPrint,
  faTrophy,
  faTv,
  faCartPlus,
  faCalendarDay,
  faBusinessTime,
  faFileAlt,
  faChalkboardTeacher,
  faBlog,
  faCompressArrowsAlt,
  faTruck,
  faCog,
} from "@fortawesome/free-solid-svg-icons";

import * as myConstClass from "../constant.js";

import Landing from "../pages/careers/Landing";
import LandingCareer from "../pages/careers/careerpublic";
import LandingCareerCompany from "../pages/careers/Careernew";

import {
  Translator,
  T,
  TF,
  LanguageList,
  Config,
} from "react-translator-component";

Config.list = {
  KH: { text: "Khemer", file: require("../locale/KH.js") },
  en: { text: "English", file: require("../locale/en.js") },
  ch: { text: "Chinese", file: require("../locale/ch.js") },
  Mal: { text: "Malaysian", file: require("../locale/Mal.js") },
};
Config.default = localStorage.getItem("lang");

// ─── Async page imports ───────────────────────────────────────────────────────

const Default = async(() => import("../pages/dashboards/Default"));
const AiAgent = async(() => import("../pages/ai_agent/AgentPage"));
const RouteAiAgent = async(() => import("../pages/ai_agent/AiAssistant"));

// Signup Request
const SListing = async(() => import("../pages/signup/Listing"));
const SView   = async(() => import("../pages/signup/view"));
const SMsg    = async(() => import("../pages/signup/message"));

// HR Admin
const HRListing = async(() => import("../pages/hradmin/Listing"));
const HRAdd     = async(() => import("../pages/hradmin/Validation"));

// Employee
const EListing         = async(() => import("../pages/employee/Listing"));
const EAdd             = async(() => import("../pages/employee/Validation"));
const EProfile         = async(() => import("../pages/employee/profileinfo"));
const EProfilee        = async(() => import("../pages/employee/profile"));
const EListingDocs     = async(() => import("../pages/employee/ListingDocs"));
const EListingAssts    = async(() => import("../pages/employee/ListingAssts"));
const EListingPoints   = async(() => import("../pages/employee/ListingPoints"));
const EListingPromotions = async(() => import("../pages/employee/morepromotions"));
const Acesscode        = async(() => import("../pages/employee/Acesscode"));
const JobInfo          = async(() => import("../pages/employee/Jobinfo"));

// Employee bulk import
const EbAdd              = async(() => import("../pages/employee_bulk_import/Import"));
const EbAddPayrollNote   = async(() => import("../pages/employee_bulk_import/ImportPayrollNote"));
const EhAdd              = async(() => import("../pages/holiday_bulk_import/Import"));
const ETLeaves           = async(() => import("../pages/leaves/Listingtemp"));
const EDLeaves           = async(() => import("../pages/leaves/ListingDel"));
const ADLeaves           = async(() => import("../pages/attendance/ListingDel"));
const ODLeaves           = async(() => import("../pages/organization/ListingDel"));
const OAttedanceKPI      = async(() => import("../pages/projects/ListingOrg"));
const OKPI               = async(() => import("../pages/projects/ListingAttendanceKPI"));
const DDLeaves           = async(() => import("../pages/department/ListingDel"));
const DDHolidays         = async(() => import("../pages/holidays/dListing"));
const EbSettAdd          = async(() => import("../pages/employee_bulk_import/ImportSettlement"));
const EbSettAddAll       = async(() => import("../pages/employee_bulk_import/ImportSettlementAll"));
const EDependandAddAll   = async(() => import("../pages/employee_bulk_import/ImportDependant"));
const ELeaveImportAddAll = async(() => import("../pages/employee_bulk_import/ImportLeave"));
const EAssetsImportAddAll= async(() => import("../pages/employee_bulk_import/ImportAssets"));
const ESalaryImportAddAll= async(() => import("../pages/employee_bulk_import/ImportSalary"));
const EAttenceImport     = async(() => import("../pages/employee_bulk_import/ImportAttendance"));
const ImTask             = async(() => import("../pages/employee_bulk_import/ImportTasks"));

// Organization
const OListing  = async(() => import("../pages/organization/Listing"));
const OAdd      = async(() => import("../pages/organization/Validation"));
const OSListing = async(() => import("../pages/organizationseries/Listing"));
const OSAdd     = async(() => import("../pages/organizationseries/Validation"));

// Attendance
const EASListing      = async(() => import("../pages/activityempset/Listing"));
const EASAdd          = async(() => import("../pages/activityempset/Validation"));
const EASKPI          = async(() => import("../pages/activityempset/Validationkpi"));
const EASummaryListing= async(() => import("../pages/activityempsetsummary/Listing"));
const EASummaryAdd    = async(() => import("../pages/activityempsetsummary/validationSummary"));
const ATLListing      = async(() => import("../pages/activitylogemp/Listing"));
const ATLAdd          = async(() => import("../pages/activitylogemp/Validation"));
const OTRListing      = async(() => import("../pages/otrequest/Listing"));
const OTRAdd          = async(() => import("../pages/otrequest/Validation"));
const OTRDListing     = async(() => import("../pages/otrequest/ListingDel"));
const IssueListing    = async(() => import("../pages/empissue/Listing"));
const IssueAdd        = async(() => import("../pages/empissue/Validation"));
const AListing        = async(() => import("../pages/attendance/Listing"));
const Closelisting    = async(() => import("../pages/reports/CloseRecord"));
const ALTisting       = async(() => import("../pages/attendance/ListingTimmy"));
const AAdd            = async(() => import("../pages/attendance/Validation"));
const TAdd            = async(() => import("../pages/attendance/ValidationTimmy"));
const AView           = async(() => import("../pages/attendance/view"));
const BView           = async(() => import("../pages/attendance/checkinout"));
const BSView          = async(() => import("../pages/attendance/checkinoutsecurity"));
const BSSView         = async(() => import("../pages/attendance/ListingChecinout"));
const AbsenceListing  = async(() => import("../pages/absent/Listing"));
const GAdd            = async(() => import("../pages/groupattendance/Validation"));
const BSVieww         = async(() => import("../pages/attendance/ListingCheckoutSecurity"));

// Guests
const GListing    = async(() => import("../pages/guests/Listing"));
const GView       = async(() => import("../pages/guests/view"));
const GCheckinout = async(() => import("../pages/guests/Validation"));

// Leaves
const LListing = async(() => import("../pages/leaves/Listing"));
const LAdd     = async(() => import("../pages/leaves/Validation"));

// Assets
const AssListing = async(() => import("../pages/assets/Listing"));
const AssAdd     = async(() => import("../pages/assets/Validation"));

// Announcements
const AnListing = async(() => import("../pages/announcements/Listing"));
const AnAdd     = async(() => import("../pages/announcements/Validation"));

// Admin app
const AdListing  = async(() => import("../pages/adminapp/Listing"));
const AdAdd      = async(() => import("../pages/adminapp/Validation"));
const AdDListing = async(() => import("../pages/adminapp/dListing"));

// Org groups (super)
const OrgGrpListing = async(() => import("../pages/org_group/Listing"));
const OrgGrpAdd     = async(() => import("../pages/org_group/Validation"));

// HR Letter
const hrLetterListing = async(() => import("../pages/hrletter/Listing"));
const hrLetterAdd     = async(() => import("../pages/hrletter/Validationdis"));

// Groups
const GroupsListing       = async(() => import("../pages/groups/Listing"));
const GroupsEmpListing    = async(() => import("../pages/groupattendance/Listing"));
const GroupsValidation    = async(() => import("../pages/groupattendance/Validation"));
const GroupsValidationLogs= async(() => import("../pages/groupattendance/ListingEmpLog"));
const GroupsAdd           = async(() => import("../pages/groups/Validation"));
const GroupsAddEmp        = async(() => import("../pages/groups/ValidationGemp"));

const ProjectgroupsListing  = async(() => import("../pages/project_groups/Listing"));
const ProjectGroupsAddEmp   = async(() => import("../pages/project_groups/ValidationGemp"));
const ProjectGroupsAddEmpNw = async(() => import("../pages/project_groups/Validation"));

// Document type
const DocListing     = async(() => import("../pages/document_type/Listing"));
const DocAdd         = async(() => import("../pages/document_type/Validation"));
const NoteEmpListing = async(() => import("../pages/document_type/ListingEmpNote"));
const SettEmpListing = async(() => import("../pages/document_type/ListingEmpSet"));
const DocEmpListing  = async(() => import("../pages/document_type/ListingEmp"));

// Allowance type
const ALLoListing = async(() => import("../pages/allownce_type/Listing"));
const ALLoAdd     = async(() => import("../pages/allownce_type/Validation"));

// Category type
const CattypeListing = async(() => import("../pages/category_type/Listing"));
const CattypeAdd     = async(() => import("../pages/category_type/Validation"));

// Blog category / sub-category (sub admin)
const HrBlogCattypeListing    = async(() => import("../pages/category/Listing"));
const HrBlogCattypeAdd        = async(() => import("../pages/category/Validation"));
const HrBlogSubCattypeListing = async(() => import("../pages/subcategory/Listing"));
const HrBlogSubCattypeAdd     = async(() => import("../pages/subcategory/Validation"));

// Ticket category
const Ticketcategory    = async(() => import("../pages/ticketcategory/Listing"));
const TicketcategoryAdd = async(() => import("../pages/ticketcategory/Validation"));

// Complaint type
const CompTypeListing = async(() => import("../pages/complaint_type/Listing"));
const CompTypeAdd     = async(() => import("../pages/complaint_type/Validation"));

// Blog type
const BlogTypeListing = async(() => import("../pages/blog_type/Listing"));
const BlogTypeAdd     = async(() => import("../pages/blog_type/Validation"));

// Job type / title / id
const JobTypeListing  = async(() => import("../pages/job_type/Listing"));
const JobTypeAdd      = async(() => import("../pages/job_type/Validation"));
const JobTitleListing = async(() => import("../pages/job_title/Listing"));
const JobTitleAdd     = async(() => import("../pages/job_title/Validation"));
const JobIDListing    = async(() => import("../pages/job_id/Listing"));
const JobIDAdd        = async(() => import("../pages/job_id/Validation"));

// Announcement type
const AnnoucementTypeListing = async(() => import("../pages/annoucement_type/Listing"));
const AnnoucementTypeAdd     = async(() => import("../pages/annoucement_type/Validation"));

// Course type
const CourseTypeListing = async(() => import("../pages/course_type/Listing"));
const CourseTypeAdd     = async(() => import("../pages/course_type/Validation"));

// EPF / SOCSO / OT / EIS
const EpfTypeListing = async(() => import("../pages/epf/Listing"));
const EpfTypeAdd     = async(() => import("../pages/epf/Validation"));
const SocTypeListing = async(() => import("../pages/soc/Listing"));
const SocTypeAdd     = async(() => import("../pages/soc/Validation"));
const OtTypeListing  = async(() => import("../pages/ottype/Listing"));
const OtTypeAdd      = async(() => import("../pages/ottype/Validation"));
const EisTypeListing = async(() => import("../pages/eis/Listing"));
const EisTypeAdd     = async(() => import("../pages/eis/Validation"));

// Allowance code
const ALLCoListing = async(() => import("../pages/allownce_code/Listing"));
const ALLCoAdd     = async(() => import("../pages/allownce_code/Validation"));

// Note code
const NoteListing = async(() => import("../pages/note_code/Listing"));
const NoteAdd     = async(() => import("../pages/note_code/Validation"));

// Tax code
const TaxListing = async(() => import("../pages/tax_code/Listing"));
const TaxAdd     = async(() => import("../pages/tax_code/Validation"));

// Pay code
const PAListing = async(() => import("../pages/paycode/Listing"));
const PAAdd     = async(() => import("../pages/paycode/Validation"));

// Promotions
const PListing = async(() => import("../pages/promotions/Listing"));
const PAdd     = async(() => import("../pages/promotions/Validation"));

// Logs
const SLListing = async(() => import("../pages/logs/Listing"));

// Public holidays
const PublicHolidayListing = async(() => import("../pages/holidays/Listing"));
const PublicHolidayAdd     = async(() => import("../pages/holidays/Validation"));

// Employee groups
const empGroupListing = async(() => import("../pages/employee_groups/Listing"));
const empGroupAdd     = async(() => import("../pages/employee_groups/Validation"));

// Complaints
const complaintsListing    = async(() => import("../pages/complaints/Listing"));
const complaintsAdd        = async(() => import("../pages/complaints/Validation"));
const ComplaintScoreListing= async(() => import("../pages/complaints/ListingComment"));

// Tax (marital / my tax table)
const MtaxCodeListing      = async(() => import("../pages/marital_status/Listing"));
const MtaxCodeAdd          = async(() => import("../pages/marital_status/Validation"));
const MtaxtableCodeListing = async(() => import("../pages/maleshian_tax_code_my/Listing"));
const MtaxtableCodeAdd     = async(() => import("../pages/maleshian_tax_code_my/Validation"));

// Blogs
const blogsListing        = async(() => import("../pages/blog/Listing"));
const blogsAdd            = async(() => import("../pages/blog/Validation"));
const blogsCommentListing = async(() => import("../pages/blog/ListingComment"));
const blogsCommentAdd     = async(() => import("../pages/blog/ValidationComment"));

// Roles
const rolesListing    = async(() => import("../pages/roles/Listing"));
const rolesAdd        = async(() => import("../pages/roles/Validation"));
const sarolesListing  = async(() => import("../pages/saroles/Listing"));
const sarolesAdd      = async(() => import("../pages/saroles/Validation"));
const sarolesDListing = async(() => import("../pages/saroles/dListing"));

// Department
const MasterDepartmentListing = async(() => import("../pages/department/Listing"));
const MasterDepartmentAdd     = async(() => import("../pages/department/Validation"));

// Payroll privilege
const PayrollPrivilegeListing = async(() => import("../pages/payrollprivalage/Listing"));
const PayrollPrivilegeAdd     = async(() => import("../pages/payrollprivalage/Validation"));

// Payslip
const NoticepayslipListClose = async(() => import("../pages/payslip/noticePayslips"));
const payslipList            = async(() => import("../pages/payslip/Listing"));
const payslipListClose       = async(() => import("../pages/payslip/ListingClose"));
const viewPayslip            = async(() => import("../pages/payslip/View_payslip"));
const Payrolltable           = async(() => import("../pages/payslip/Payrolltable"));
const payslippdf             = async(() => import("../pages/payslip/Payslip_pdf"));

// My profile
const Mprofile = async(() => import("../pages/myprofile/Add"));

// Shifts
const shiftListing            = async(() => import("../pages/shifts/Listing"));
const shiftAdd                = async(() => import("../pages/shifts/Validation"));
const taxBracketListing       = async(() => import("../pages/tax_brackets/Listing"));
const taxBracketAdd           = async(() => import("../pages/tax_brackets/Validation"));
const shiftSchedularImport    = async(() => import("../pages/shift_schedular/Importschedular"));
const shiftSchedularList      = async(() => import("../pages/shift_schedular/Listing"));
const shiftSchedularListHistory= async(() => import("../pages/shift_schedular/ListingHistory"));
const shiftSchedularAdd       = async(() => import("../pages/shift_schedular/Validation"));

// Payroll line entry
const payrollLineEnrtyAdd        = async(() => import("../pages/payroll_line_entry/Validation"));
const payrollLineEnrtyAddAdmin   = async(() => import("../pages/payroll_line_entry/Validationadmin"));
const payrollLineEntryList       = async(() => import("../pages/payroll_line_entry/Listing"));
const payrollLineEntryListAdd    = async(() => import("../pages/payroll_line_entry/ListingAdd"));
const payrollLineEntryListAddClose  = async(() => import("../pages/payroll_line_entry/ListingClose"));
const payrollLineEntryListAddCancel = async(() => import("../pages/payroll_line_entry/Listingcancel"));
const payrollLineEntryListAdmin  = async(() => import("../pages/payroll_line_entry/Listingadmin"));
const payrollLineEntryListTest   = async(() => import("../pages/payroll_line_entry/ListingTest"));
const payslipImport              = async(() => import("../pages/payroll_line_entry/Import_payslip_data"));
const payslipImportExport        = async(() => import("../pages/payroll_line_entry/Data"));
const payslipImportExportEdit    = async(() => import("../pages/payroll_line_entry/DataValidation"));
const payslipImportExportBefore  = async(() => import("../pages/payroll_line_entry/DataBeforePayroll"));
const payslipImportExportBeforeNp= async(() => import("../pages/payroll_line_entry/DataBeforePayrollNoticePay"));
const paidInstruction            = async(() => import("../pages/payroll_line_entry/ValidationPaid"));
const paidImport                 = async(() => import("../pages/payroll_line_entry/Import_paid_instruction"));
const payrollreport              = async(() => import("../pages/payroll_line_entry/report"));
const allPayrollreport           = async(() => import("../pages/payroll_line_entry/allreports"));

// Custom report
const signinCustom = async(() => import("../pages/reportscustom/projectsReport"));

// Leave type
const leaveTypeListing  = async(() => import("../pages/leave_type/Listing"));
const leaveTypeAdd      = async(() => import("../pages/leave_type/Validation"));
const leaveTypeDListing = async(() => import("../pages/leave_type/dListing"));

// Admin / security staff
const adminStaffListing    = async(() => import("../pages/admin_staff/Listing"));
const adminStaffAdd        = async(() => import("../pages/admin_staff/Validation"));
const securityStaffAdd     = async(() => import("../pages/admin_staff/ValidationSecurity"));
const securityStaffListing = async(() => import("../pages/admin_staff/ListingSecurity"));

// Product category / product / order
const ProductcatgoryListing = async(() => import("../pages/productcategory/Listing"));
const ProductcatgoryAdd     = async(() => import("../pages/productcategory/Validation"));
const superadminStaffListing= async(() => import("../pages/superadmin_staff/Listing"));
const superadminStaffAdd    = async(() => import("../pages/superadmin_staff/Validation"));
const ProductListing = async(() => import("../pages/product/Listing"));
const ProductAdd     = async(() => import("../pages/product/Validation"));
const ProductShop    = async(() => import("../pages/product/shop"));
const CardAdd        = async(() => import("../pages/product/shopproducts"));
const CartAdd        = async(() => import("../pages/product/cartinfo"));
const ShopAdd        = async(() => import("../pages/product/moreinfo"));
const TopproductAdd  = async(() => import("../pages/product/shoptopproducts"));
const OrderListing   = async(() => import("../pages/order/Listing"));
const OrderAdd       = async(() => import("../pages/order/Validation"));

// Points
const PublicPointListing       = async(() => import("../pages/points/Listing"));
const PublicPointAdd           = async(() => import("../pages/points/Validation"));
const PublicPointDeleteListing = async(() => import("../pages/points/dListing"));

// Payroll headers
const PayrollheadersListing = async(() => import("../pages/Payrollheaders/Listing"));
const PayrollheadersAdd     = async(() => import("../pages/Payrollheaders/Validation"));

// Job description / post
const JobdescListing = async(() => import("../pages/job_descripation/Listing"));
const Jobdisc        = async(() => import("../pages/job_descripation/Validationdis"));
const JobdescAdd     = async(() => import("../pages/job_descripation/Validation"));
const JobdescCard    = async(() => import("../pages/job_descripation/jpbdesccard"));
const JobpostListing = async(() => import("../pages/jobpost/Listing"));
const JobpostAdd     = async(() => import("../pages/jobpost/Validation"));
const Applist        = async(() => import("../pages/jobpost/Applicantlisting"));
const JApplist       = async(() => import("../pages/jobpost/JobpostAppListing"));

// Incident
const IListing = async(() => import("../pages/incident/Listing"));
const IAdd     = async(() => import("../pages/incident/Validation"));
const IAddI    = async(() => import("../pages/incident/Add"));
const IAddM    = async(() => import("../pages/incident/Addmedia"));
const IVidieo  = async(() => import("../pages/incident/Vidieo"));

// Messages
const MsgListing = async(() => import("../pages/empmsg/Chat"));

// Courses
const CourseListing  = async(() => import("../pages/course/Listing"));
const CourseAdd      = async(() => import("../pages/course/Validation"));
const NoticePayCheckListing = async(() => import("../pages/notice_pay_check/Listing"));
const NoticePayCheckAdd     = async(() => import("../pages/notice_pay_check/Validation"));
const ChaptorListing = async(() => import("../pages/chaptors/Listing"));
const ChaptorAdd     = async(() => import("../pages/chaptors/Validation"));
const TopicAdd       = async(() => import("../pages/chaptors/Validationtopic"));
const Vidieo         = async(() => import("../pages/chaptors/Vidieo"));
const Videoselfjs    = async(() => import("../pages/chaptors/Avidieo"));

// Projects / tasks
const ProjectListing      = async(() => import("../pages/projects/Listing"));
const ProjectAdd          = async(() => import("../pages/projects/Validation"));
const ProjecttasksListing = async(() => import("../pages/projectstasks/Listing"));
const ProjecttasksAdd     = async(() => import("../pages/projectstasks/Validation"));

// Banner / bank / HR fields
const BAListing     = async(() => import("../pages/banner/Listing"));
const BAAdd         = async(() => import("../pages/banner/Validation"));
const BankListing   = async(() => import("../pages/bank/Listing"));
const BankAdd       = async(() => import("../pages/bank/Validation"));
const HRFieldListing= async(() => import("../pages/hr_field/Listing"));
const HRFieldAdd    = async(() => import("../pages/hr_field/Validation"));

// Activity type / status / valuation
const ActivityTypeListing       = async(() => import("../pages/activity_type/Listing"));
const ActivityTypeAdd           = async(() => import("../pages/activity_type/Validation"));
const ActivityStatusListing     = async(() => import("../pages/activity_status/Listing"));
const ActivityStatusAdd         = async(() => import("../pages/activity_status/Validation"));
const ActivityValuationListing  = async(() => import("../pages/activity_valution/Listing"));
const ActivityValuationAdd      = async(() => import("../pages/activity_valution/Validation"));
const AttendanceValuationListing= async(() => import("../pages/attendance_valution/Listing"));
const AttendanceValuationAdd    = async(() => import("../pages/attendance_valution/Validation"));

// Reports
const noticePayReport     = async(() => import("../pages/reports/noticePayReport"));
const payrollReports      = async(() => import("../pages/reports/payrollReport"));
const projectsReports     = async(() => import("../pages/reports/projectsReport"));
const staffingReports     = async(() => import("../pages/reports/staffingReport"));
const LeaveReports        = async(() => import("../pages/reports/leaveReport"));
const AttendanceOrgKPI    = async(() => import("../pages/attendance/ListingAttOrgKpi"));
const AttendanceEmpKPI    = async(() => import("../pages/attendance/ListingAttEmpKpi"));
const EmployeeEvalutionReports = async(() => import("../pages/reports/employeeEvalutionReport"));
const EmployeeEvalutionVation  = async(() => import("../pages/reports/Validation"));

// ─── Read session values ──────────────────────────────────────────────────────

var admin_id           = localStorage.getItem("uname");
var pro_package        = localStorage.getItem("package");
var login_id           = localStorage.getItem("login_id");
var login_type         = localStorage.getItem("login_type");
var custom             = localStorage.getItem("custom");
var login_role         = localStorage.getItem("role_modules");
var company_name       = localStorage.getItem("company_name");
let storedNames        = localStorage.getItem("sub_admin_roles");
var sub_admin_role     = localStorage.getItem("sub_admin_role");
var paylineprivilage   = localStorage.getItem("emppayline");
var is_sub_admin_with_payroll = localStorage.getItem("is_sub_admin_with_payroll");
var admin_settings     = localStorage.getItem("admin_settings");
var admin_promotions   = localStorage.getItem("admin_promotions");
var admin_hradmin      = localStorage.getItem("admin_hradmin");
var admin_logs         = localStorage.getItem("admin_logs");
var signuprequest      = localStorage.getItem("signuprequest");
var admin_adminstaff   = localStorage.getItem("admin_adminstaff");
var hr_work_plan       = localStorage.getItem("hr_work_plan");
var hr_emp_careeer     = localStorage.getItem("hr_emp_careeer");
var hr_emp_training    = localStorage.getItem("hr_emp_training");
var hr_emp_msg         = localStorage.getItem("hr_emp_msg");
var hr_emp_shop        = localStorage.getItem("hr_emp_shop");
var hr_emp_promotions  = localStorage.getItem("hr_emp_promotions");
var hr_emp_annoucements= localStorage.getItem("hr_emp_annoucements");
var hr_emp_blogs       = localStorage.getItem("hr_emp_blogs");
var hr_emp_guests      = localStorage.getItem("hr_emp_guests");
var is_super_user      = localStorage.getItem("is_super_user");
var hr_emp_evalution   = localStorage.getItem("hr_emp_evalution");
var hr_emp_reports     = localStorage.getItem("hr_emp_reports");
var hr_emp_activity    = localStorage.getItem("hr_emp_activity");
var hr_emp_issue       = localStorage.getItem("hr_emp_issue");
var hr_group           = localStorage.getItem("hr_group");
var hr_blogs           = localStorage.getItem("hr_blogs");
var hr_letter          = localStorage.getItem("hr_letter");
var is_timmy_machine   = localStorage.getItem("is_timmy_machine");

// Privilege message presets
localStorage.setItem("edit_msg",   "Do not have Edit Privilege");
localStorage.setItem("add_msg",    "Do not have Add Privilege");
localStorage.setItem("delete_msg", "Do not have Delete Privilege");
localStorage.setItem("view_msg",   "Do not have Privilege");

// ─── Permission fetch helpers ─────────────────────────────────────────────────

// Maps index → localStorage key suffix for add/edit/delete permission fetches
const permissionMap = [
  [0,  "emppre"],   [2,  "empabs"],   [7,  "empann"],  [8,  "empblog"],
  [10, "empmsg"],   [9,  "empapp"],   [14, "emptrain"],[16, "empjurl"],
  [17, "empprom"],  [20, "empplogs"], [21, "empcheckin"],[22,"empirep"],
  [24, "empleave"], [23, "empleavet"],[25, "empemp"],  [26, "empgrp"],
  [27, "empcomp"],  [28, "empsubadmin"],[29,"empsecurity"],[30,"emporg"],
  [31, "empholiday"],[32,"empdept"],  [33, "emppoint"],[34, "empjd"],
  [35, "emptax"],   [36, "emppayline"],[37,"emppayslip"],[38,"emppaycode"],
  [39, "empshift"], [40, "empschduler"],[41,"empschdulerimp"],[42,"emppcat"],
  [43, "emppro"],   [44, "emporder"], [45, "empbanner"],[46,"empcourse"],
  [47, "empjobpost"],[48,"empa_applist"],[49,"empproject"],[50,"emptask"],
  [51, "emprole"],  [52, "empassets"],[53, "allowtype"],[54,"empallocode"],
  [55, "empnote"],  [56, "empdocu"],  [57, "doctype"],
  [59, "compcat"],  [60, "comptype"], [61, "blgtype"], [62,"jbtype"],
  [63, "anntype"],  [64, "coursetype"],[65,"empdoc"],
];

function setPermissions(response, suffix) {
  permissionMap.forEach(([idx, key]) => {
    localStorage.setItem(`${key}_${suffix}`, response[idx]);
  });
}

fetch(myConstClass.BASE_URL + "organization/getaddAgainstInfo_Page/" + sub_admin_role)
  .then(r => r.json())
  .then(response => setPermissions(response, "add"))
  .catch(err => console.log(err));

fetch(myConstClass.BASE_URL + "organization/geteditAgainstInfo_Page/" + sub_admin_role)
  .then(r => r.json())
  .then(response => setPermissions(response, "edit"))
  .catch(err => console.log(err));

fetch(myConstClass.BASE_URL + "organization/getdeleteAgainstInfo_Page/" + sub_admin_role)
  .then(r => r.json())
  .then(response => setPermissions(response, "delete"))
  .catch(err => console.log(err));

// ─── Organization / sub-admin role setup ─────────────────────────────────────

if (is_super_user == "0") {
  if (sub_admin_role == 0) {
    localStorage.setItem("organization_sub_admin", localStorage.getItem("org_id_payroll"));
  } else {
    fetch(myConstClass.BASE_URL + "organization/getrolesInfo/" + sub_admin_role)
      .then(r => r.json())
      .then(response => {
        localStorage.setItem("organization_sub_admin", response.organization_id.replace(/,/g, "-"));
        localStorage.setItem("department_sub_admin",   response.department.replace(/,/g, "-"));
      })
      .catch(err => console.log(err));
  }
} else if (is_super_user != "0") {
  fetch(myConstClass.BASE_URL + "user/getSuperAdminStaffInfo/" + is_super_user)
    .then(r => r.json())
    .then(response => {
      localStorage.setItem("organization_sub_admin", response.organization_id.replace(",", "-"));
      localStorage.setItem("department_sub_admin", "0");
    })
    .catch(err => console.log(err));
}

// ─── Module flags (sub_admin) ─────────────────────────────────────────────────

let myArraymodules;
let easstes = 0, eallowancwtype = 0, eallowancecode = 0, enotecode = 0,
    empdoc = 0, doctype = 0, ep = 0, ea = 0, eann = 0, eapp = 0, eblog = 0,
    emsg = 0, ejurl = 0, eprom = 0, elogs = 0, echeck = 0, eincident = 0,
    eleavetype = 0, eleave = 0, eemp = 0, egrp = 0, ecmp = 0, esubadmin = 0,
    esec = 0, eorg = 0, eholiday = 0, edept = 0, epoint = 0, ejd = 0,
    ebracket = 0, epayroll = 0, epayslip = 0, epaycode = 0, eshift = 0,
    escheduler = 0, eshiftreport = 0, eprocat = 0, epro = 0, eorder = 0,
    ebanner = 0, ecourse = 0, ejobpost = 0, eapplist = 0, eprojects = 0,
    etasks = 0, eroles = 0, empgrp = 0, compcat = 0, comptype = 0, bltype = 0,
    jbtype = 0, anntype = 0, coutype = 0, empdocum = 0, schhistory = 0;

// Helper: map module array index to variable setter
function setModuleFlag(arr, idx, setter) {
  setter(arr[idx] == "0" ? "0" : "1");
}

if (is_sub_admin_with_payroll == "1") {
  if (storedNames != null && storedNames != "0") {
    myArraymodules = storedNames.split(",");
  }
  if (myArraymodules != undefined) {
    const m = myArraymodules;
    ep          = m[0]  == "0" ? "0" : "1"; if (ep  == "1") localStorage.setItem("presnse_view", "1");
    ea          = m[2]  == "0" ? "0" : "1";
    eann        = m[7]  == "0" ? "0" : "1";
    eapp        = m[9]  == "0" ? "0" : "1";
    eblog       = m[8]  == "0" ? "0" : "1";
    localStorage.setItem("msgnot", m[10]);
    emsg        = m[10] == "0" ? "0" : "1";
    ejurl       = m[16] == "0" ? "0" : "1";
    eprom       = m[17] == "0" ? "0" : "1";
    elogs       = m[20] == "0" ? "0" : "1";
    echeck      = m[21] == "0" ? "0" : "1";
    eincident   = m[22] == "0" ? "0" : "1";
    localStorage.setItem("leavenot", m[24]);
    eleave      = m[24] == "0" ? "0" : "1"; if (eleave == "1") localStorage.setItem("leave_view", "1");
    eleavetype  = m[23] == "0" ? "0" : "1";
    egrp        = m[26] == "0" ? "0" : "1";
    eemp        = m[25] == "0" ? "0" : "1"; if (eemp  == "1") localStorage.setItem("empview", "1");
    localStorage.setItem("comnot", m[27]);
    ecmp        = m[27] == "0" ? "0" : "1";
    esubadmin   = m[28] == "0" ? "0" : "1";
    esec        = m[29] == "0" ? "0" : "1";
    eorg        = m[30] == "0" ? "0" : "1"; if (eorg  == "1") localStorage.setItem("orgview", "1");
    eholiday    = m[31] == "0" ? "0" : "1";
    edept       = m[32] == "0" ? "0" : "1";
    epoint      = m[33] == "0" ? "0" : "1";
    ejd         = m[34] == "0" ? "0" : "1";
    ebracket    = m[35] == "0" ? "0" : "1";
    epayroll    = m[36] == "0" ? "0" : "1";
    epayslip    = m[37] == "0" ? "0" : "1";
    epaycode    = m[38] == "0" ? "0" : "1";
    eshift      = m[39] == "0" ? "0" : "1";
    escheduler  = m[40] == "0" ? "0" : "1";
    eshiftreport= m[41] == "0" ? "0" : "1";
    eprocat     = m[42] == "0" ? "0" : "1";
    epro        = m[43] == "0" ? "0" : "1";
    localStorage.setItem("ordernot", m[44]);
    eorder      = m[44] == "0" ? "0" : "1";
    ebanner     = m[45] == "0" ? "0" : "1";
    ecourse     = m[46] == "0" ? "0" : "1";
    ejobpost    = m[47] == "0" ? "0" : "1";
    eapplist    = m[48] == "0" ? "0" : "1";
    eprojects   = m[49] == "0" ? "0" : "1";
    etasks      = m[50] == "0" ? "0" : "1";
    eroles      = m[51] == "0" ? "0" : "1";
    easstes     = m[52] == "0" ? "0" : "1";
    eallowancwtype  = m[53] == "0" ? "0" : "1";
    eallowancecode  = m[54] == "0" ? "0" : "1";
    enotecode       = m[55] == "0" ? "0" : "1";
    empdoc      = m[56] == "0" ? "0" : "1"; if (empdoc == "1") localStorage.setItem("docnot", m[56]);
    doctype     = m[57] == "0" ? "0" : "1";
    empgrp      = m[58] == "0" ? "0" : "1";
    compcat     = m[59] == "0" ? "0" : "1";
    comptype    = m[60] == "0" ? "0" : "1";
    bltype      = m[61] == "0" ? "0" : "1";
    jbtype      = m[62] == "0" ? "0" : "1";
    anntype     = m[63] == "0" ? "0" : "1";
    coutype     = m[64] == "0" ? "0" : "1";
    empdocum    = m[65] == "0" ? "0" : "1";
    schhistory  = m[66] == "0" ? "0" : "1";
  }
}

if (is_sub_admin_with_payroll == "2") {
  epayroll = "1";
  epayslip = "1";
}

// ─── Path setup ──────────────────────────────────────────────────────────────

let ten_path, file_ten_path, dashboardR;
let PromotionSuper, SettingsSuper, HRAdminSuper, RolesSuper,
    SystemLogsSuper, AdminStaffSuper, SignupSuper;

if (window.location.href) {
  var str2 = window.location.href.split("/");
  if (str2.length <= 4 && str2[3] != "super_admin") {
    ten_path      = "/pages/auth/page404";
    file_ten_path = "";
    dashboardR    = "/auth/404";
  } else {
    var url = window.location.pathname;
    var str = url.split("/");

    if (login_role != null) {
      PromotionSuper  = admin_promotions  == "true" ? "1" : "0";
      SettingsSuper   = admin_settings    == "true" ? "1" : "0";
      HRAdminSuper    = admin_hradmin     == "true" ? "1" : "0";
      SignupSuper     = "1"; // always 1 regardless of signuprequest value (original logic)
      SystemLogsSuper = admin_logs        == "true" ? "1" : "0";
      AdminStaffSuper = admin_adminstaff  == "true" ? "1" : "0";
    }

    if (str[1] && str[1] != "undefined" && str[2] && str[2] != "undefined") {
      ten_path      = str[1] + "/" + str[2];
      file_ten_path = "/" + ten_path;
      if (login_type == "emp") {
        dashboardR = "/" + ten_path + "/employees/profileinfo";
      } else if (login_type == "security") {
        dashboardR = hr_emp_guests == "true"
          ? "/" + ten_path + "/guests/listing"
          : "/" + ten_path + "/shiftsattendance/ListingCheckoutSecurity";
      } else {
        dashboardR = "/" + ten_path + "/dashboard";
      }
    } else if (str[1] && str[1] != "undefined") {
      ten_path      = str[1];
      file_ten_path = "/" + ten_path;
      dashboardR    = "/" + ten_path + "/dashboard";
    }
  }
}

// ─── Route definitions ────────────────────────────────────────────────────────

const landingRoutesNew = {
  path: "/career/:id",
  name: "Job Frontend Url",
  icon: faHome,
  target: "_blank",
  component: LandingCareer,
  children: null,
};

const landingRoutesNewCompany = {
  path: "/careercompany/:id",
  name: "Career",
  icon: faHome,
  target: "_blank",
  component: LandingCareerCompany,
  children: null,
};

let landingRoutesNewCompanyEmp = (login_type == "emp" && hr_emp_careeer == "true")
  ? { path: "/careercompany/" + company_name, name: "Career", icon: faHome, target: "_blank", component: LandingCareerCompany, children: null }
  : { path: "x" };

let landingRoutes = (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 &&
   login_type != "emp" && login_type != "security" && login_type != "sub_admin") ||
  (ejurl == "1" && login_type == "sub_admin")
) ? { path: file_ten_path + "/careers", name: "Job Frontend Url", icon: faHome, target: "_blank", component: Landing, children: null }
  : { path: "x" };

let SignCustomRoutes = (login_type == "hr_admin" && custom == 1)
  ? { path: file_ten_path + "/reportscustom/listing", name: "Custom Report", icon: faVolumeUp, component: signinCustom, children: null }
  : { path: "x" };

let dashboardRoutes;
if (login_type != "emp" && login_type != "security" && (custom == "0" || custom == null)) {
  dashboardRoutes = { path: dashboardR, name: "Dashboard", icon: faHome, component: Default, children: null };
} else if (login_type == "security") {
  dashboardRoutes = hr_emp_guests == "true"
    ? { path: file_ten_path + "/guests/listing", name: "Visitor", icon: faUserFriends, component: GListing, children: null }
    : { path: file_ten_path + "/shiftsattendance/ListingCheckoutSecurity", name: "Employee List", icon: faImages, component: BSVieww, children: null };
} else if (login_type == "emp") {
  dashboardRoutes = { path: file_ten_path + "/employees/profileinfo", name: "My Profile", header: "Main", icon: faUserTie, component: EProfile, children: null };
} else {
  dashboardRoutes = { path: "x" };
}

let signupRoutes;
if (admin_id == 1 || (login_type == "super_admin" && SignupSuper == "1")) {
  signupRoutes = { path: file_ten_path + "/signup/listing", name: localStorage.getItem("96"), icon: faIdCard, component: SListing, children: null };
} else {
  signupRoutes = { path: "x" };
}

let logs;
if (admin_id == 1 || (login_type == "super_admin" && SystemLogsSuper == "1")) {
  logs = { path: file_ten_path + "/logs/listing", name: "System Logs", icon: faIdCard, component: SLListing, children: null };
} else {
  logs = { path: "x" };
}

let profile;
if (login_type == "emp" || login_type == "hr_admin" || login_type == "sub_admin") {
  profile = { path: file_ten_path + "/myprofile/add", name: "My Profile", icon: faUserCircle, component: Mprofile, children: null };
} else {
  profile = { path: "x" };
}

// ─── Employee routes ──────────────────────────────────────────────────────────

let empRoutes;
var arrayemployee    = [];
var arrayemployeeHr  = [];

const baseEmpEntries = [
  { path: file_ten_path + "/employeescomplaints/listing", name: "Comments", icon: faVolumeUp, component: complaintsListing, children: null },
  { path: file_ten_path + "/employeesadmin_staff/listing", name: "Sub Admin", icon: faUserFriends, component: adminStaffListing, children: null },
  { path: file_ten_path + "/employeesadmin_staff/listingsecurity", name: "Security", icon: faUserFriends, component: securityStaffListing, children: null },
  { path: file_ten_path + "/employeesadmin_staff/listingdocs", name: "Documents", icon: faUserFriends, component: DocEmpListing, children: null },
  { path: file_ten_path + "/employeesissues/listing", name: "Employee Issues", icon: faClock, component: IssueListing, children: null },
  { path: file_ten_path + "/employees/listingnote", name: "Note", icon: faUserFriends, component: NoteEmpListing, children: null },
  { path: file_ten_path + "/employees/listingsettlement", name: "Settlement", icon: faUserFriends, component: SettEmpListing, children: null },
  { path: file_ten_path + "/employees/importsettlementall", name: "Settlement Import", icon: faUserFriends, component: EbSettAddAll, children: null },
  { path: file_ten_path + "/employees/importdependant", name: "Dependant Import", icon: faUserFriends, component: EDependandAddAll, children: null },
  { path: file_ten_path + "/employees/importleave", name: "Leave Import", icon: faUserFriends, component: ELeaveImportAddAll, children: null },
  { path: file_ten_path + "/employees/importassets", name: "Assets Import", icon: faUserFriends, component: EAssetsImportAddAll, children: null },
  { path: file_ten_path + "/employees/importsalary", name: "Salary Import", icon: faUserFriends, component: ESalaryImportAddAll, children: null },
];

const isHrAdmin = admin_id != 1 && login_type != "super_admin" && pro_package != 0 &&
  login_type != "emp" && login_type != "security" && login_type != "sub_admin";

if (isHrAdmin) {
  const baseWithEmp = [{ path: file_ten_path + "/employees/listing", name: "Employee", component: EListing }];
  if (hr_emp_activity == "true") {
    baseWithEmp.push(
      { path: file_ten_path + "/employeestaregetactvity/listing", name: "Employee Monthly Target", icon: faClock, component: EASListing, children: null },
      { path: file_ten_path + "/employeesactivity/listing", name: "Employee Log Activity", icon: faClock, component: ATLListing, children: null },
      { path: file_ten_path + "/employeestaregetsummaryactvity/listing", name: "Employee Summary Target Activity", icon: faClock, component: EASummaryListing, children: null }
    );
  }
  arrayemployeeHr.push(...baseWithEmp, ...baseEmpEntries);
}

if (login_type == "sub_admin" && eemp  == "1") arrayemployee.push({ path: file_ten_path + "/employees/listing", name: "Employee", icon: faUserFriends, component: EListing, children: null });
if (login_type == "sub_admin" && esubadmin == "1") arrayemployee.push({ path: file_ten_path + "/employeesadmin_staff/listing", name: "Sub Admin", icon: faUserFriends, component: adminStaffListing, children: null });
if (login_type == "sub_admin" && esec  == "1") arrayemployee.push({ path: file_ten_path + "/employeesadmin_staff/listingsecurity", name: "Security", icon: faUserFriends, component: securityStaffListing, children: null });
if (login_type == "sub_admin" && empdoc== "1") arrayemployee.push({ path: file_ten_path + "/employeesadmin_staff/listingdocs", name: "Documents", icon: faUserFriends, component: DocEmpListing, children: null });

if (login_type == "sub_admin" && arrayemployee.length > 0) {
  empRoutes = { path: file_ten_path + "/employees", name: "Employee", icon: faUserFriends, children: arrayemployee };
} else if (isHrAdmin && pro_package != 0) {
  empRoutes = { path: file_ten_path + "/employees", name: "Employee", icon: faUserFriends, children: arrayemployeeHr };
} else if (isHrAdmin && pro_package == 0) {
  empRoutes = { path: file_ten_path + "/employees", name: "Employee", icon: faUserFriends, children: [
    { path: file_ten_path + "/employees/listing", name: "Employee", icon: faUserFriends, component: EListing, children: null },
    { path: file_ten_path + "/employeesissues/listing", name: "Employee Issues", icon: faClock, component: IssueListing, children: null },
  ]};
} else if (login_type == "emp" && pro_package != 1 && login_type != "sub_admin" && is_timmy_machine == "0") {
  empRoutes = { path: file_ten_path + "/employeescomplaints/listing", name: "Comments", icon: faVolumeUp, component: complaintsListing, children: null };
} else {
  empRoutes = { path: "x" };
}

let ComplaintRoutes = (login_type == "emp" && is_timmy_machine == "0")
  ? { path: file_ten_path + "/employeescomplaints/listing", name: "Comments", icon: faExclamationTriangle, component: complaintsListing, children: null }
  : { path: "x" };

// ─── Settings routes ──────────────────────────────────────────────────────────

let SettingRoutes;
let SettingRoutesEmp = (login_type == "emp" && hr_emp_careeer == "true")
  ? { path: file_ten_path + "/careerjob_descripation/listing", name: "Job Description", icon: faBusinessTime, component: JobdescListing, children: null }
  : { path: "x" };

var arraysettingshr = [];

if (isHrAdmin && pro_package != 0) {
  arraysettingshr.push(
    { path: file_ten_path + "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing, children: null },
    { path: file_ten_path + "/settingsorganizationseries/listing", name: "Organization Series", icon: faLandmark, component: OSListing, children: null },
    { path: file_ten_path + "/settingspayrollheaders/listing", name: "Payroll Headers", icon: faLandmark, component: PayrollheadersListing, children: null },
    { path: file_ten_path + "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing, children: null },
    { path: file_ten_path + "/settingsdepartment/listing", name: "Master Department", icon: faVolumeUp, component: MasterDepartmentListing, children: null },
    { path: file_ten_path + "/settingspoints/listing", name: "Point Declaration", icon: faVolumeUp, component: PublicPointListing, children: null },
    { path: file_ten_path + "/settingssaroles/listing", name: "User Role", icon: faBlog, component: sarolesListing, children: null },
    { path: file_ten_path + "/settingsleave_type/listing", name: "Leave Types", icon: faTable, component: leaveTypeListing, children: null },
    { path: file_ten_path + "/settingsadminapp/listing", name: "Admin Apps", icon: faMobile, component: AdListing, children: null },
    { path: file_ten_path + "/settingsassets/listing", name: "Assets", icon: faBlog, component: AssListing, children: null },
    { path: file_ten_path + "/settingsallownce_type/listing", name: "Settlement Type", icon: faBlog, component: ALLoListing, children: null },
    { path: file_ten_path + "/settingsallownce_code/listing", name: "Settlement Code", icon: faBlog, component: ALLCoListing, children: null },
    { path: file_ten_path + "/settingsnote_code/listing", name: "Note Code", icon: faBlog, component: NoteListing, children: null },
    { path: file_ten_path + "/settingsdocument_type/listing", name: "Document Types", icon: faBlog, component: DocListing, children: null },
    { path: file_ten_path + "/settings_groups/listing", name: "Employee Groups", component: empGroupListing },
    { path: file_ten_path + "/settingscategory_type/listing", name: "Comment Category", icon: faBlog, component: CattypeListing, children: null },
    { path: file_ten_path + "/settingscomplaint_type/listing", name: "Comment Type", icon: faBlog, component: CompTypeListing, children: null },
    { path: file_ten_path + "/settingsannoucement_type/listing", name: "Annoucement Type", icon: faBlog, component: AnnoucementTypeListing, children: null },
    { path: file_ten_path + "/settingspayrollPrivilege/listing", name: "Payroll Privilege", icon: faBlog, component: PayrollPrivilegeListing, children: null },
    { path: file_ten_path + "/settingsnoticepaycheck/listing", name: "Notice Pay Check", icon: faBlog, component: NoticePayCheckListing, children: null },
    { path: file_ten_path + "/settingsbank/listing", name: "Bank", icon: faBlog, component: BankListing, children: null },
    { path: file_ten_path + "/settingshrfields/listing", name: "HR Letter Fields", icon: faBlog, component: HRFieldListing, children: null },
    { path: file_ten_path + "/settingsattendansevalution/listing", name: "Attendance Remarks", icon: faBlog, component: AttendanceValuationListing, children: null },
    { path: file_ten_path + "/settingsmarital_status/listing", name: "Marital Code", icon: faBlog, component: MtaxCodeListing, children: null },
    { path: file_ten_path + "/settingsmytaxtable/listing", name: "My Tax Table", icon: faBlog, component: MtaxtableCodeListing, children: null },
    { path: file_ten_path + "/settings_epf/listing", name: "EPF", icon: faBlog, component: EpfTypeListing, children: null },
    { path: file_ten_path + "/settings_soc/listing", name: "SOCSO", icon: faBlog, component: SocTypeListing, children: null },
    { path: file_ten_path + "/settingseis/listing", name: "EIS", icon: faBlog, component: EisTypeListing, children: null },
    { path: file_ten_path + "/settingsot/listing", name: "OT Type", icon: faBlog, component: OtTypeListing, children: null }
  );
  if (hr_emp_training == "true") arraysettingshr.push({ path: file_ten_path + "/settingsc_type/listing", name: "Course Type", icon: faBlog, component: CourseTypeListing, children: null });
  if (hr_emp_blogs    == "true") arraysettingshr.push({ path: file_ten_path + "/settingsblog_type/listing", name: "Blog Type", icon: faBlog, component: BlogTypeListing, children: null });
  arraysettingshr.push({ path: file_ten_path + "/settingsticketcategory/listing", name: "Ticket Category", icon: faBlog, component: Ticketcategory, children: null });
  if (hr_emp_activity == "true") arraysettingshr.push(
    { path: file_ten_path + "/settingsactivitytype/listing", name: "Activity Type", icon: faBlog, component: ActivityTypeListing, children: null },
    { path: file_ten_path + "/settingsactivitystatus/listing", name: "Activity Status", icon: faBlog, component: ActivityStatusListing, children: null },
    { path: file_ten_path + "/settingsactivityevalution/listing", name: "Activity Valuation %", icon: faBlog, component: ActivityValuationListing, children: null }
  );
  SettingRoutes = { path: file_ten_path + "/settings", name: "Settings", icon: faCog, children: arraysettingshr };
} else if (isHrAdmin && pro_package == 0) {
  SettingRoutes = { path: file_ten_path + "/settings", name: "Settings", icon: faCog, children: [
    { path: file_ten_path + "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing, children: null },
    { path: file_ten_path + "/settingsadminapp/listing", name: "Admin Apps", icon: faMobile, component: AdListing, children: null },
    { path: file_ten_path + "/settingsdepartment/listing", name: "Master Department", icon: faVolumeUp, component: MasterDepartmentListing, children: null },
    { path: file_ten_path + "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing, children: null },
    { path: file_ten_path + "/settingsleave_type/listing", name: "Leave Types", icon: faTable, component: leaveTypeListing, children: null },
    { path: file_ten_path + "/settingsticketcategory/listing", name: "Ticket Category", icon: faBlog, component: Ticketcategory, children: null },
  ]};
} else if ((admin_id == 1 && login_id == 1) || (login_type == "super_admin" && SettingsSuper == "1")) {
  SettingRoutes = { path: file_ten_path + "/settings", name: "Settings", icon: faCog, children: [
    { path: file_ten_path + "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing, children: null },
    { path: file_ten_path + "/settingsadminapp/listing", name: "Admin Apps", icon: faMobile, component: AdListing, children: null },
    { path: file_ten_path + "/settingscategory/listing", name: "Category", icon: faBlog, component: HrBlogCattypeListing, children: null },
    { path: file_ten_path + "/settingssubcategory/listing", name: "Sub Category", icon: faBlog, component: HrBlogSubCattypeListing, children: null },
  ]};
} else if (login_type == "emp") {
  SettingRoutes = { path: file_ten_path + "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing, children: null };
} else {
  SettingRoutes = { path: "x" };
}

// Sub-admin settings
if (login_type == "sub_admin") {
  var arraysettings = [];
  if (eorg   == "1") arraysettings.push({ path: file_ten_path + "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing, children: null });
  if (eholiday=="1") arraysettings.push({ path: file_ten_path + "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing, children: null });
  if (edept  == "1") arraysettings.push({ path: file_ten_path + "/settingsdepartment/listing", name: "Master Department", icon: faVolumeUp, component: MasterDepartmentListing, children: null });
  if (epoint == "1") arraysettings.push({ path: file_ten_path + "/settingspoints/listing", name: "Point Declaration", icon: faVolumeUp, component: PublicPointListing, children: null });
  if (eroles == "1") arraysettings.push({ path: file_ten_path + "/settingssaroles/listing", name: "User Role", icon: faBlog, component: sarolesListing, children: null });
  if (eleavetype=="1") arraysettings.push({ path: file_ten_path + "/settingsleave_type/listing", name: "Leave Types", icon: faTable, component: leaveTypeListing, children: null });
  if (eapp   == "1") arraysettings.push({ path: file_ten_path + "/settingsadminapp/listing", name: localStorage.getItem("49"), icon: faMobile, component: AdListing, children: null });
  if (easstes== "1") arraysettings.push({ path: file_ten_path + "/settingsassets/listing", name: "Assets", icon: faBlog, component: AssListing, children: null });
  if (eallowancwtype=="1") arraysettings.push({ path: file_ten_path + "/settingsallownce_type/listing", name: "Settlement Type", icon: faBlog, component: ALLoListing, children: null });
  if (eallowancecode=="1") arraysettings.push({ path: file_ten_path + "/settingsallownce_code/listing", name: "Settlement Code", icon: faBlog, component: ALLCoListing, children: null });
  if (enotecode=="1") arraysettings.push({ path: file_ten_path + "/settingsnote_code/listing", name: "Note Code", icon: faBlog, component: NoteListing, children: null });
  if (doctype == "1") arraysettings.push({ path: file_ten_path + "/settingsdocument_type/listing", name: "Document Types", icon: faLandmark, component: DocListing, children: null });
  if (egrp   == "1") arraysettings.push({ path: file_ten_path + "/settings_groups/listing", name: "Employee Groups", icon: faVolumeUp, component: empGroupListing, children: null });
  if (empgrp == "1") arraysettings.push({ path: file_ten_path + "/settings_groups/listing", name: "Employee Groups", component: empGroupListing });
  if (compcat== "1") arraysettings.push({ path: file_ten_path + "/settingscategory_type/listing", name: "Comment Category", icon: faBlog, component: CattypeListing, children: null });
  if (comptype=="1") arraysettings.push({ path: file_ten_path + "/settingscomplaint_type/listing", name: "Comment Type", icon: faBlog, component: CattypeListing, children: null });
  if (bltype == "1") arraysettings.push({ path: file_ten_path + "/settingsblog_type/listing", name: "Blog Type", icon: faBlog, component: BlogTypeListing, children: null });
  if (anntype== "1") arraysettings.push({ path: file_ten_path + "/settingsannoucement_type/listing", name: "Announcement Type", icon: faBlog, component: AnnoucementTypeListing, children: null });
  if (coutype== "1") arraysettings.push({ path: file_ten_path + "/settingsc_type/listing", name: "Course Type", icon: faBlog, component: CourseTypeListing, children: null });

  if (arraysettings.length > 0) {
    SettingRoutes = { path: file_ten_path + "/settings", name: "Settings", icon: faCog, children: arraysettings };
  } else {
    SettingRoutes = { path: "x" };
  }
}

// ─── Static route objects ─────────────────────────────────────────────────────

const empRoutes1 = {
  path: "/employees/listing", name: "Employee", icon: faUserFriends, component: EListing,
  children: [
    { path: file_ten_path + "/employees/add", component: EAdd },
    { path: file_ten_path + "/employees/profile", component: EProfilee },
  ],
};

const MYprofile1 = {
  path: file_ten_path + "/myprofile/add", name: "My Profile", icon: faUserCircle,
  children: [{ path: file_ten_path + "/myprofile/Add", component: Mprofile }],
};

const Mytaxcode1 = {
  path: file_ten_path + "/settingsmarital_status/listing", name: "Marital Code", icon: faUserFriends, component: MtaxCodeListing,
  children: [{ path: file_ten_path + "/settingsmarital_status/add", component: MtaxCodeAdd }],
};

const Mytaxtable1 = {
  path: file_ten_path + "/settingsmytaxtable/listing", name: "My Tax Table", icon: faUserFriends, component: MtaxtableCodeListing,
  children: [{ path: file_ten_path + "/settingsmytaxtable/add", component: MtaxtableCodeAdd }],
};

let empBulkRoutes = (admin_id != 1 || login_type != "super_admin")
  ? { path: file_ten_path + "/employees_bulk_import/import", name: "Import", icon: faUserFriends, component: EbAdd, children: null }
  : { path: file_ten_path + "/employees_bulk_import/import", name: "", icon: "", children: null };

const empPayrollNoteBulkRoutes = {
  path: file_ten_path + "/payroll_note_import/import", name: "Import", icon: faUserFriends, component: EbAddPayrollNote, children: null,
};

let empSettlementBulkRoutes = (admin_id != 1 || login_type != "super_admin")
  ? { path: file_ten_path + "/employee_bulk_import/importsettlement", name: "Import Settlement", icon: faUserFriends, component: EbSettAdd, children: null }
  : { path: file_ten_path + "/employee_bulk_import/importsettlement", name: "", icon: "", children: null };

let empSettlementBulkRoutesAll = (admin_id != 1 || login_type != "super_admin")
  ? { path: file_ten_path + "/employees/importsettlementall", name: "Import Settlement", icon: faUserFriends, component: EbSettAddAll, children: null }
  : { path: file_ten_path + "/employees/importsettlementall", name: "", icon: "", children: null };

let holidayBulkRoutes = (admin_id != 1 || login_type != "super_admin")
  ? { path: file_ten_path + "/holiday_bulk_import/import", name: "Import Settlement", icon: faUserFriends, component: EhAdd, children: null }
  : { path: file_ten_path + "/holiday_bulk_import/import", name: "", icon: "", children: null };

const jobdisRoutes = {
  path: file_ten_path + "/jobdisclouser", name: "Job Disclosure", icon: faLandmark, component: Jobdisc, children: null,
};

const payrollHeadersRoutes  = { path: file_ten_path + "/settingspayrollheaders/listing", name: "Payroll Headers", icon: faLandmark, component: PayrollheadersListing, children: null };
const payrollHeadersRoutes1 = {
  path: file_ten_path + "/settingspayrollheaders/add", name: "Payroll Headers", icon: faLandmark, component: PayrollheadersAdd, children: null,
};
const orgRoutes = { path: file_ten_path + "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing, children: null };
const orgRoutes1 = {
  path: "/settingsorganization/listing", name: "Organization", icon: faLandmark, component: OListing,
  children: [
    { path: file_ten_path + "/settingsorganization/add", component: OAdd },
    { path: file_ten_path + "/settingsorganization/dlisting", component: ODLeaves },
    { path: file_ten_path + "/settingsorganization/kpilisting", component: OKPI },
  ],
};
const orgRoutesSeries1 = {
  path: "/settingsorganizationseries/listing", name: "Organization Series", icon: faLandmark, component: OSListing,
  children: [{ path: file_ten_path + "/settingsorganizationseries/add", component: OSAdd }],
};

let attendanceRoutes = (admin_id != 1 && login_type != "super_admin" && login_type == "emp" && login_type != "security" && login_type != "sub_admin")
  ? { path: file_ten_path + "/shiftsattendance/listing", name: "My Attendance", icon: faClock, component: AListing, children: null }
  : { path: "x" };

let guestRoutes;
{
  const isSubAdmin = login_type == "sub_admin";
  const hasGuests  = hr_emp_guests == "true";
  const hasAll     = isSubAdmin && echeck == "1" && eincident == "1" && hasGuests;
  const checkOnly  = isSubAdmin && echeck == "1" && hasGuests;
  const inciOnly   = isSubAdmin && eincident == "1" && hasGuests;
  const hrAdmin    = (admin_id != 1 && login_type != "super_admin" && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hasGuests) ||
                     (login_type == "hr_admin" && hasGuests && pro_package == "0");

  if (hasAll) {
    guestRoutes = { path: file_ten_path + "/guests", name: "Visitor", icon: faUserFriends, children: [
      { path: file_ten_path + "/guests/listing", name: "Visitor", icon: faUserFriends, component: GListing, children: null },
      { path: file_ten_path + "/guestsincident/listing", name: "Incident Report", icon: faImages, component: IListing, children: null },
    ]};
  } else if (checkOnly) {
    guestRoutes = { path: file_ten_path + "/guests", name: "Visitor", icon: faUserFriends, children: [
      { path: file_ten_path + "/guests/listing", name: "Visitor", icon: faUserFriends, component: GListing, children: null },
    ]};
  } else if (inciOnly) {
    guestRoutes = { path: file_ten_path + "/guests", name: "Visitor", icon: faUserFriends, children: [
      { path: file_ten_path + "/guestsincident/listing", name: "Incident Report", icon: faImages, component: IListing, children: null },
    ]};
  } else if (hrAdmin) {
    guestRoutes = { path: file_ten_path + "/guests", name: "Visitor", icon: faUserFriends, children: [
      { path: file_ten_path + "/guests/listing", name: "Visitor", icon: faUserFriends, component: GListing, children: null },
      { path: file_ten_path + "/guestsincident/listing", name: "Incident Report", component: IListing },
    ]};
  } else {
    guestRoutes = { path: "x" };
  }
}

let workplanroutes;
var arrayworkplan = [];
if (login_type == "sub_admin" && eprojects == "1" && hr_work_plan == "true") {
  arrayworkplan.push({ path: file_ten_path + "/projects/listing", name: "Projects", icon: faUserFriends, component: ProjectListing, children: null });
}

let reportRoutes = (login_type == "hr_admin" && hr_emp_reports == "true")
  ? { path: file_ten_path + "/reports", name: "Reports", icon: faBook, children: [
      { path: file_ten_path + "/reports/payrollReport",  name: "Payroll Reports",       icon: faUserFriends, component: payrollReports,   children: null },
      { path: file_ten_path + "/reports/noticePayReport",name: "Notice Pay Reports",    icon: faUserFriends, component: noticePayReport,  children: null },
      { path: file_ten_path + "/reports/staffingReport", name: "Staff IN OUT Reports",  icon: faUserFriends, component: staffingReports,  children: null },
      { path: file_ten_path + "/reports/leaveReport",    name: "Leave Reports",         icon: faUserFriends, component: LeaveReports,     children: null },
    ]}
  : { path: "x" };

if (login_type == "sub_admin" && hr_work_plan == "true" && arrayworkplan.length > 0) {
  workplanroutes = { path: file_ten_path + "/projects", name: "Work Plan", icon: faProjectDiagram, children: arrayworkplan };
} else if ((login_type != "emp" && login_type != "security" && login_type != "super_admin" && login_type != "sub_admin" && hr_work_plan == "true") ||
           (login_type == "hr_admin" && hr_work_plan == "true" && pro_package == "0")) {
  workplanroutes = { path: file_ten_path + "/projects", name: "Work Plan/KPI", icon: faProjectDiagram, component: ProjectListing, children: [
    { path: file_ten_path + "/projects/listing",               name: "Work Plan",                              component: ProjectListing,   children: null },
    { path: file_ten_path + "/projects/projectsReport",        name: "KPI of completed Project",               component: projectsReports,  children: null },
    { path: file_ten_path + "/projects/attendaceKPIEmp",       name: "KPI Attendance Employee",                component: AttendanceEmpKPI, children: null },
    { path: file_ten_path + "/projects/attendaceKPI",          name: "KPI Attendance Organization",            component: AttendanceOrgKPI, children: null },
    { path: file_ten_path + "/projects/attendaceKPIOrganization", name: "KPI Attendance Organization Listing", component: OAttedanceKPI,    children: null },
  ]};
} else if (login_type == "emp" && is_timmy_machine == "0") {
  workplanroutes = { path: file_ten_path + "/projects", name: "Work Plan/KPI", icon: faProjectDiagram, component: ProjectListing, children: [
    { path: file_ten_path + "/projects/listing", name: "Work Plan", component: ProjectListing, children: null },
  ]};
} else {
  workplanroutes = { path: "x" };
}

let employeeEvalutionReport = (login_type == "hr_admin" && hr_emp_evalution == "true")
  ? { path: file_ten_path + "/evalutions/listing", name: "Workplan Evaluation", component: EmployeeEvalutionReports, icon: faAward, children: null }
  : { path: "x" };

const workpjectroutes1 = {
  path: file_ten_path + "/projects/listing", name: "Check In Out", icon: faUserFriends, component: ProjectListing,
  children: [
    { path: file_ten_path + "/projects/add", component: ProjectAdd },
    { path: file_ten_path + "/project/ImportTask", name: "Task Import", icon: faUserFriends, component: ImTask, children: null },
  ],
};

const workreport1 = {
  path: file_ten_path + "/evalutions/listing", name: "Employee Evalution Report", component: EmployeeEvalutionReports,
  children: [{ path: file_ten_path + "/evalutions/add", component: EmployeeEvalutionVation }],
};

const workpjectroutestasks = {
  path: file_ten_path + "/projectstasks/listing", name: "Project Task", component: ProjecttasksListing, icon: faAward, children: null,
};

const workpjectroutestasks1 = {
  path: file_ten_path + "/projectstasks/listing", name: "Project Task", icon: faUserFriends, component: ProjecttasksListing,
  children: [{ path: file_ten_path + "/projectstasks/add", component: ProjecttasksAdd }],
};

const attendanceRoutes1 = {
  path: file_ten_path + "/shiftsattendance/listing", name: "Employee Presense", icon: faClock, component: AListing,
  children: [
    { path: file_ten_path + "/shiftsattendance/add",     component: AAdd    },
    { path: file_ten_path + "/shiftsattendance/view",    component: AView   },
    { path: file_ten_path + "/shiftsattendance/dlisting",component: ADLeaves},
    { path: file_ten_path + "/shiftsattendance/TAdd",    component: TAdd    },
  ],
};

const guestRoutes1 = {
  path: file_ten_path + "/guests/listing", name: "Visitor", icon: faUserFriends, component: GListing,
  children: [
    { path: file_ten_path + "/guests/view",                           component: GView       },
    { path: file_ten_path + "/guests/checkinout",                     component: GCheckinout },
    { path: file_ten_path + "/shiftsattendance/checkinoutsecurity",   component: BSView      },
    { path: file_ten_path + "/shiftsattendance/morechecinout",        component: BSSView     },
  ],
};

let absentRoutes = (
  (admin_id != 1 && login_type != "super_admin" && login_type != "emp" && login_type != "security" && login_type != "sub_admin") ||
  (ea == "1" && login_type == "sub_admin")
) ? { path: file_ten_path + "/absent/listing", name: "Absent", component: AbsenceListing, icon: faUserSlash, children: null }
  : { path: "x" };

const absentRoutes1 = {
  path: file_ten_path + "/absent/listing", name: "Absent", icon: faClock, component: AbsenceListing,
  children: [
    { path: file_ten_path + "/shiftsattendance/add/:id", component: AAdd },
    { path: "/shiftsattendance/view/:id",               component: AView },
  ],
};

let leaveRoutes = (login_type == "emp")
  ? { path: file_ten_path + "/shiftsleaves/listing", name: "My Leaves", icon: faCalendarDay, component: LListing, children: null }
  : { path: "x" };

let leaveBankRoutes = (login_type == "emp")
  ? { path: file_ten_path + "/shiftsleaves/Listingemp", name: "Leave Bank", icon: faCalendarDay, component: ETLeaves }
  : { path: "x" };

const leaveRoutes1 = {
  path: file_ten_path + "/shiftsleaves/listing", name: "My Leaves", icon: faCalendarDay, component: LListing,
  children: [
    { path: file_ten_path + "/shiftsleaves/add",     component: LAdd     },
    { path: file_ten_path + "/shiftsleaves/dlisting",component: EDLeaves },
  ],
};

let announcementRoutes = (
  (admin_id != 1 && login_type != "super_admin" && login_type != "security" && login_type != "sub_admin") ||
  (eann == "1" && login_type == "sub_admin")
) ? { path: file_ten_path + "/announcements/listing", name: "Announcements", icon: faVolumeUp, component: AnListing, children: null }
  : { path: "x" };

const announcementRoutes1 = {
  path: file_ten_path + "/announcements/listing", name: "Announcements", icon: faVolumeUp, component: AnListing,
  children: [{ path: file_ten_path + "/announcements/add", component: AnAdd }],
};

let promotionRoutes;
if (
  (admin_id != 1 && login_type != "super_admin" && hr_emp_promotions == "true" && login_type != "emp" && login_type != "security" && login_type != "sub_admin") ||
  (eprom == "1" && login_type == "sub_admin") ||
  (login_type == "hr_admin" && hr_emp_promotions == "true" && pro_package == "0") ||
  (login_type == "super_admin" && PromotionSuper == "1")
) {
  promotionRoutes = { path: file_ten_path + "/promotions/listing", name: "Business Promotions", icon: faImages, component: PListing, children: null };
} else {
  promotionRoutes = { path: "x" };
}

const promotionRoutes1 = {
  path: file_ten_path + "/promotions/listing", name: "Business Promotions", icon: faImages, component: PListing,
  children: [{ path: file_ten_path + "/promotions/add", component: PAdd }],
};

const adminappRoutes1 = {
  path: file_ten_path + "/settingsadminapp/listing", name: "Admin App", icon: faVolumeUp, component: AdListing,
  children: [
    { path: file_ten_path + "/settingsadminapp/add",     component: AdAdd     },
    { path: file_ten_path + "/settingsadminapp/dlisting",component: AdDListing},
  ],
};
const adminappRoutes = { path: file_ten_path + "/settingsadminapp/listing", name: "Admin App", icon: faVolumeUp, component: AdListing, children: null };

const payrollroutes = { path: file_ten_path + "/payroll_line_entry/adminlisting", name: "Payroll Line Entry Admin", icon: faVolumeUp, component: payrollLineEntryListAdmin, children: null };
const payrollroutes1 = {
  path: file_ten_path + "/payroll_line_entry/adminlisting", name: "Payroll Line Entry Admin", icon: faVolumeUp, component: payrollLineEntryListAdmin,
  children: [
    { path: file_ten_path + "/payroll_line_entry/addadminp",            component: payrollLineEnrtyAddAdmin      },
    { path: file_ten_path + "/payroll_line_entry/import_payslip_data",  component: payslipImport                 },
    { path: file_ten_path + "/payroll_line_entry/data",                 component: payslipImportExportBefore     },
    { path: file_ten_path + "/payroll_line_entry/datanp",               component: payslipImportExportBeforeNp  },
    { path: file_ten_path + "/payroll_line_entry/dataprocessedit",      component: payslipImportExportEdit       },
    { path: file_ten_path + "/payroll_line_entry/dataprocess",          component: payslipImportExport           },
    { path: file_ten_path + "/payroll_line_entry/reoprt",               component: payrollreport                 },
    { path: file_ten_path + "/payroll_line_entry/allreports",           component: allPayrollreport              },
    { path: file_ten_path + "/payroll_line_entry/listingtest",          component: payrollLineEntryListTest      },
    { path: file_ten_path + "/payslip/Payslip_pdf/:id",                 component: payslippdf                    },
    { path: file_ten_path + "/payslip/View_payslip/:id/:id2",           component: viewPayslip                   },
    { path: file_ten_path + "/payslip/Payrolltable",                    component: Payrolltable                  },
    { path: file_ten_path + "/payroll/PaidInstruction",                 component: paidInstruction               },
    { path: file_ten_path + "/payroll/importpaid",                      component: paidImport                    },
  ],
};

const holidayRoutes  = { path: file_ten_path + "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing, children: null };
const holidayRoutes1 = {
  path: "/settingsholidays/listing", name: "Public Holiday", icon: faVolumeUp, component: PublicHolidayListing,
  children: [
    { path: file_ten_path + "/settingsholidays/add",     component: PublicHolidayAdd },
    { path: file_ten_path + "/settingsholidays/dlisting",component: DDHolidays       },
  ],
};

const DepartmentRoutes  = { path: file_ten_path + "/settingsdepartment/listing", name: "Master Department", icon: faVolumeUp, component: MasterDepartmentListing, children: null };
const DepartmentRoutes1 = {
  path: "/department/listing", name: "Master Department", icon: faVolumeUp, component: MasterDepartmentListing,
  children: [
    { path: file_ten_path + "/settingsdepartment/add",     component: MasterDepartmentAdd },
    { path: file_ten_path + "/settingsdepartment/dlisting",component: DDLeaves            },
  ],
};

const empGroupRoutes  = { path: file_ten_path + "/settings_groups/listing", name: "Employee Groups", icon: faVolumeUp, component: empGroupListing, children: null };
const empGroupRoutes1 = {
  path: file_ten_path + "/settings_groups/listing", name: "Employee Groups", icon: faVolumeUp, component: empGroupListing,
  children: [{ path: file_ten_path + "/settings_groups/add", component: empGroupAdd }],
};

const complaintsRoutes  = { path: file_ten_path + "/employeescomplaints/listing", name: "Comments", icon: faVolumeUp, component: complaintsListing, children: null };
const complaintsRoutes1 = {
  path: file_ten_path + "/employeescomplaints/listing", name: "Comments", icon: faVolumeUp, component: complaintsListing,
  children: [
    { path: file_ten_path + "/employeescomplaints/add",  component: complaintsAdd         },
    { path: file_ten_path + "/employeescomplaints/score",component: ComplaintScoreListing },
  ],
};

let bannerRoutes;
if (admin_id != 1 && login_type != "super_admin" && login_type != "security") {
  bannerRoutes = { path: file_ten_path + "/shopsbanner/listing", name: "Banner", icon: faImages, component: BAListing, children: null };
} else {
  bannerRoutes = { path: file_ten_path + "/shopsbanner/listing", name: "Banner", icon: faImages, component: BAListing, children: null };
}

const bannerRoutes1 = {
  path: file_ten_path + "/shopsbanner/listing", name: "Banner", icon: faImages, component: BAListing,
  children: [{ path: file_ten_path + "/shopsbanner/add", component: BAAdd }],
};

let empcheckinoutRoutes = (login_type == "security" && hr_emp_guests == "true")
  ? { path: file_ten_path + "/shiftsattendance/ListingtingsCheckoutSecurity", name: "Employee List", icon: faImages, component: BSVieww, children: null }
  : { path: "x" };

let incidentRoutes = (login_type == "security" && hr_emp_guests == "true")
  ? { path: file_ten_path + "/guestsincident/listing", name: "Incident Report", icon: faImages, component: IListing, children: null }
  : { path: "x" };

let MsgRoutes;
if (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_emp_msg == "true") ||
  (emsg == "1" && login_type == "sub_admin" && hr_emp_msg == "true") ||
  (login_type == "hr_admin" && hr_emp_msg == "true" && pro_package == "0")
) {
  MsgRoutes = { path: file_ten_path + "/empmsg/listing", name: "Employee Chat", icon: faCommentAlt, component: MsgListing, children: null };
} else if (login_type == "emp" && pro_package != 0 && hr_emp_msg == "true") {
  MsgRoutes = { path: file_ten_path + "/empmsg/listing", name: "Messages", icon: faCommentAlt, component: MsgListing, children: null };
} else {
  MsgRoutes = { path: "x" };
}

const incidentRoutes1 = {
  path: file_ten_path + "/guestsincident/listing", name: "Incident Report", icon: faImages, component: IListing,
  children: [
    { path: file_ten_path + "/guestsincident/add",    component: IAdd   },
    { path: file_ten_path + "/guestsincident/addi",   component: IAddI  },
    { path: file_ten_path + "/guestsincident/addm",   component: IAddM  },
    { path: file_ten_path + "/guestsincident/vidieo", component: IVidieo},
  ],
};

let employetrainingRoutes;
if (login_type == "sub_admin" && ecourse == "1" && hr_emp_training == "true") {
  employetrainingRoutes = { path: file_ten_path + "/course", name: "Employee Training", icon: faChalkboardTeacher, children: [
    { path: file_ten_path + "/course/listing", name: "Course", icon: faChalkboardTeacher, component: CourseListing, children: null },
  ]};
} else if (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_emp_training == "true") ||
  (login_type == "hr_admin" && hr_emp_training == "true" && pro_package == "0")
) {
  employetrainingRoutes = { path: file_ten_path + "/course", name: "Employee Training", icon: faChalkboardTeacher, children: [
    { path: file_ten_path + "/course/listing", name: "Course", icon: faChalkboardTeacher, component: CourseListing, children: null },
  ]};
} else if (login_type == "emp" && pro_package != 0 && login_type != "sub_admin" && hr_emp_training == "true") {
  employetrainingRoutes = { path: file_ten_path + "/course/listing", name: "Training", icon: faChalkboardTeacher, component: CourseListing, children: null };
} else {
  employetrainingRoutes = { path: "x" };
}

const employetrainingRoutes1 = {
  path: file_ten_path + "/course/listing", name: "Course", icon: faChalkboardTeacher, component: CourseListing,
  children: [
    { path: file_ten_path + "/course/add",            component: CourseAdd    },
    { path: file_ten_path + "/chaptors/add",           component: ChaptorAdd  },
    { path: file_ten_path + "/chaptors/addtopic",      component: TopicAdd    },
    { path: file_ten_path + "/chaptors/listing",       component: ChaptorListing },
    { path: file_ten_path + "/chaptors/vidieo",        component: Vidieo      },
    { path: file_ten_path + "/application/videoself",  component: Videoselfjs },
  ],
};

const taxRoutes1 = {
  path: file_ten_path + "payrollpayroll_line_entry/taxlisting", name: "Tax Code", icon: faBlog, component: TaxListing,
  children: [{ path: file_ten_path + "/payroll_line_entry/taxadd", component: TaxAdd }],
};

let groupsRoutes;
if (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_group == "true") ||
  (login_type == "hr_admin" && pro_package != "0" && hr_group == "true")
) {
  groupsRoutes = { path: file_ten_path + "/groups", name: "Groups", icon: faBlog, component: GroupsListing, children: [
    { path: file_ten_path + "/groups/listing",          name: "Groups CheckIN",           component: GroupsListing       },
    { path: file_ten_path + "/groups/attendanselogs",   name: "Groups Attendance Logs",   component: GroupsEmpListing    },
    { path: file_ten_path + "/projectgroups/listing",   name: "Project Groups",           component: ProjectgroupsListing},
  ]};
} else {
  groupsRoutes = { path: "x" };
}

const groupsRoutes1 = {
  path: file_ten_path + "/groups/listing", name: "Groups CheckIN", icon: faBlog, component: GroupsListing,
  children: [
    { path: file_ten_path + "/groups/add",                  component: GroupsAdd           },
    { path: file_ten_path + "/groups/addEmp",               component: GroupsAddEmp        },
    { path: file_ten_path + "/groupsattendanse/add",        component: GroupsValidation    },
    { path: file_ten_path + "/groupsattendanse/editlogs",   component: GroupsValidationLogs},
    { path: file_ten_path + "/project_groups/addEmp",       component: ProjectGroupsAddEmpNw},
    { path: file_ten_path + "/project_groups/add",          component: ProjectGroupsAddEmp },
  ],
};

let HrblogRoutes, HrletterRoutes;

if (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_letter == "true") ||
  (login_type == "hr_admin" && pro_package != "0" && hr_letter == "true")
) {
  HrletterRoutes = { path: file_ten_path + "/hrLetterListing", name: "HR Letters", icon: faBlog, component: hrLetterListing, children: [
    { path: file_ten_path + "/hrLetterListing/listing", name: "HR Letters", component: hrLetterListing },
  ]};
} else {
  HrletterRoutes = { path: "x" };
}

const HrletterRoutes1 = {
  path: file_ten_path + "/hrLetterListing/listing", name: "HR Letters", icon: faBlog, component: hrLetterListing,
  children: [{ path: file_ten_path + "/hrLetterListing/add", component: hrLetterAdd }],
};

if (
  (admin_id == 1 && login_type == "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_blogs == "true") ||
  (login_type == "hr_admin" && pro_package != 0 && hr_blogs == "true")
) {
  HrblogRoutes = { path: file_ten_path + "/org_group/listing", name: "HR Blog", icon: faBlog, component: OrgGrpListing, children: null };
} else {
  HrblogRoutes = { path: "x" };
}

let blogRoutes;
if (
  (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_emp_blogs == "true") ||
  (eblog == "1" && login_type == "sub_admin" && hr_emp_blogs == "true") ||
  (login_type == "hr_admin" && hr_emp_blogs == "true" && pro_package == "0")
) {
  blogRoutes = { path: file_ten_path + "/blog/listing", name: "Organization Blog", icon: faBlog, component: blogsListing, children: null };
} else if (pro_package != 0 && login_type == "emp" && hr_emp_blogs == "true") {
  blogRoutes = { path: file_ten_path + "/blog/listing", name: "Organization Blogs", icon: faBlog, component: blogsListing, children: null };
} else {
  blogRoutes = { path: "x" };
}

let rolesRoutes = ((admin_id == 1 && login_id == 1) || (login_type == "super_admin" && admin_id == 1 && RolesSuper == "1"))
  ? { path: file_ten_path + "/roles/listing", name: localStorage.getItem("95"), icon: faBlog, component: rolesListing, children: null }
  : { path: "x" };

let sarolesRoutes = (login_type == "sub_admin" && eroles == "1") || login_type == "hr_admin"
  ? { path: file_ten_path + "/settingssaroles/listing", name: "User Role", icon: faBlog, component: sarolesListing, children: null }
  : { path: "x" };

let assetsRoutes = (login_type == "hr_admin" || (login_type == "sub_admin" && easstes == "1"))
  ? { path: file_ten_path + "/settingsassets/listing", name: "Assets", icon: faBlog, component: AssListing, children: null }
  : { path: "x" };

let documenttypeRoutes = { path: file_ten_path + "/settingsdocument_type/listing", name: "Document Type", icon: faBlog, component: DocListing, children: null };
const documenttypeRoutes1 = {
  path: file_ten_path + "/settingsdocument_type/listing", name: "Document Type", icon: faBlog, component: DocListing,
  children: [{ path: file_ten_path + "/settingsdocument_type/add", component: DocAdd }],
};

let allowncetypeRoutes = (login_type == "hr_admin" || (login_type == "sub_admin" && eallowancwtype == "1"))
  ? { path: file_ten_path + "/settingsallownce_type/listing", name: "Settlement Type", icon: faBlog, component: ALLoListing, children: null }
  : { path: "x" };

let categorytypeRoutes = { path: file_ten_path + "/settingscategory_type/listing", name: "Comment Category", icon: faBlog, component: CattypeListing, children: null };
const categorytypeRoutes1 = {
  path: file_ten_path + "/settingscategory_type/listing", name: "Comment Category", icon: faBlog, component: CattypeListing,
  children: [{ path: file_ten_path + "/settingscategory_type/add", component: CattypeAdd }],
};

let complainttypeRoutes = { path: file_ten_path + "/settingscomplaint_type/listing", name: "Comment Type", icon: faBlog, component: CompTypeListing, children: null };
const complainttypeRoutes1 = {
  path: file_ten_path + "/settingscomplaint_type/listing", name: "Comment Type", icon: faBlog, component: CompTypeListing,
  children: [{ path: file_ten_path + "/settingscomplaint_type/add", component: CompTypeAdd }],
};

let blogtypeRoutes = { path: file_ten_path + "/settingsblog_type/listing", name: "Blog Type", icon: faBlog, component: BlogTypeListing, children: null };
const blogtypeRoutes1 = {
  path: file_ten_path + "/settingsblog_type/listing", name: "Blog Type", icon: faBlog, component: BlogTypeListing,
  children: [{ path: file_ten_path + "/settingsblog_type/add", component: BlogTypeAdd }],
};

let categoryRoutes = { path: file_ten_path + "/settingscategory/listing", name: "Category", icon: faBlog, component: HrBlogCattypeListing, children: null };
const categoryRoutes1 = {
  path: file_ten_path + "/settingscategory/listing", name: "Category", icon: faBlog, component: HrBlogCattypeListing,
  children: [{ path: file_ten_path + "/settingscategory/add", component: HrBlogCattypeAdd }],
};

let orgGroupsRoutes = { path: file_ten_path + "/org_group/listing", name: "Organization Group", icon: faBlog, component: OrgGrpListing, children: null };
const orgGroupsRoutes1 = {
  path: file_ten_path + "/org_group/listing", name: "Organization Group", icon: faBlog, component: OrgGrpListing,
  children: [{ path: file_ten_path + "/org_group/add", component: OrgGrpAdd }],
};

let subCategoryRoutes = { path: file_ten_path + "/settingssubcategory/listing", name: "Sub Category", icon: faBlog, component: HrBlogSubCattypeListing, children: null };
const subCategoryRoutes1 = {
  path: file_ten_path + "/settingssubcategory/listing", name: "Sub Category", icon: faBlog, component: HrBlogSubCattypeListing,
  children: [{ path: file_ten_path + "/settingssubcategory/add", component: HrBlogSubCattypeAdd }],
};

let coursetypeRoutes = { path: file_ten_path + "/settingsc_type/listing", name: "Course Type", icon: faBlog, component: CourseTypeListing, children: null };
const coursetypeRoutes1 = {
  path: file_ten_path + "/settingsc_type/listing", name: "Course Type", icon: faBlog, component: CourseTypeListing,
  children: [{ path: file_ten_path + "/settingsc_type/add", component: CourseTypeAdd }],
};

let epftypeRoutes = { path: file_ten_path + "/settingsepf/listing", name: "EPF", icon: faBlog, component: EpfTypeListing, children: null };
const epfRoutes1 = {
  path: file_ten_path + "/settingsepf/listing", name: "EPF", icon: faBlog, component: EpfTypeListing,
  children: [{ path: file_ten_path + "/settingsepf/add", component: EpfTypeAdd }],
};

let soctypeRoutes = { path: file_ten_path + "/settingssoc/listing", name: "SOCSO", icon: faBlog, component: SocTypeListing, children: null };
const socRoutes1 = {
  path: file_ten_path + "/settingsepf/listing", name: "SOCSO", icon: faBlog, component: SocTypeListing,
  children: [{ path: file_ten_path + "/settingssoc/add", component: SocTypeAdd }],
};

let eistypeRoutes = { path: file_ten_path + "/settingseis/listing", name: "EIS", icon: faBlog, component: EisTypeListing, children: null };
const eisRoutes1 = {
  path: file_ten_path + "/settingseis/listing", name: "EIS", icon: faBlog, component: EisTypeListing,
  children: [{ path: file_ten_path + "/settingseis/add", component: EisTypeAdd }],
};

let ottypeRoutes = { path: file_ten_path + "/settingsot/listing", name: "Ot Type", icon: faBlog, component: OtTypeListing, children: null };
const otRoutes1 = {
  path: file_ten_path + "/settingsot/listing", name: "Ot Type", icon: faBlog, component: OtTypeListing,
  children: [{ path: file_ten_path + "/settingsot/add", component: OtTypeAdd }],
};

let PayrollPrivilegeRoutes = { path: file_ten_path + "/settingspayrollPrivilege/listing", name: "Payroll Privilege", icon: faBlog, component: PayrollPrivilegeListing, children: null };
const PayrollPrivilegeRoutes1 = {
  path: file_ten_path + "/settingspayrollPrivilege/listing", name: "Payroll Privilege", icon: faBlog, component: PayrollPrivilegeListing,
  children: [{ path: file_ten_path + "/settingspayrollPrivilege/add", component: PayrollPrivilegeAdd }],
};

let NoticePayCheckRoutes = { path: file_ten_path + "/settingsnoticepaycheck/listing", name: "Notice Pay Check", icon: faBlog, component: NoticePayCheckListing, children: null };
const NoticePayCheckRoutes1 = {
  path: file_ten_path + "/settingsnoticepaycheck/listing", name: "Notice Pay Check", icon: faBlog, component: NoticePayCheckListing,
  children: [{ path: file_ten_path + "/settingsnoticepaycheck/add", component: NoticePayCheckAdd }],
};

let BankRoutes = { path: file_ten_path + "/settingsbank/listing", name: "Bank", icon: faBlog, component: BankListing, children: null };
const BankRoutes1 = {
  path: file_ten_path + "/settingsbank/listing", name: "Bank", icon: faBlog, component: BankListing,
  children: [{ path: file_ten_path + "/settingsbank/add", component: BankAdd }],
};

const HrFieldRoutes1 = {
  path: file_ten_path + "/settingshrfields/listing", name: "Hr Fields", icon: faBlog, component: HRFieldListing,
  children: [{ path: file_ten_path + "/settingshrfields/add", component: HRFieldAdd }],
};
const ActivityTypeRoutes1 = {
  path: file_ten_path + "/settingsactivitytype/listing", name: "Activity Type", icon: faBlog, component: ActivityTypeListing,
  children: [{ path: file_ten_path + "/settingsactivitytype/add", component: ActivityTypeAdd }],
};
const TicketcategoryRoutes1 = {
  path: file_ten_path + "/settingsticketcategory/listing", name: "Ticket Category", icon: faBlog, component: Ticketcategory,
  children: [{ path: file_ten_path + "/settingsticketcategory/add", component: TicketcategoryAdd }],
};
const ActivityStatusRoutes1 = {
  path: file_ten_path + "/settingsactivitystatus/listing", name: "Activity Type", icon: faBlog, component: ActivityStatusListing,
  children: [{ path: file_ten_path + "/settingsactivitystatus/add", component: ActivityStatusAdd }],
};
const ActivityvaluationRoutes1 = {
  path: file_ten_path + "/settingsactivityvaluation/listing", name: "Activity Valuation %", icon: faBlog, component: ActivityValuationListing,
  children: [{ path: file_ten_path + "/settingsactivityvaluation/add", component: ActivityValuationAdd }],
};
const AttendancevaluationRoutes1 = {
  path: file_ten_path + "/settingsattendansevalution/listing", name: "Attendance Valuation %", icon: faBlog, component: AttendanceValuationListing,
  children: [{ path: file_ten_path + "/settingsattendansevalution/add", component: AttendanceValuationAdd }],
};

let jobtypeRoutes = { path: file_ten_path + "/careerjob_type/listing", name: "Job Type", icon: faBlog, component: JobTypeListing, children: null };
const jobtypeRoutes1 = {
  path: file_ten_path + "/careerjob_type/listing", name: "Job Type", icon: faBlog, component: JobTypeListing,
  children: [{ path: file_ten_path + "/careerjob_type/add", component: JobTypeAdd }],
};
let jobtitleRoutes = { path: file_ten_path + "/careerjob_title/listing", name: "Job Title", icon: faBlog, component: JobTitleListing, children: null };
const jobtitleRoutes1 = {
  path: file_ten_path + "/careerjob_title/listing", name: "Job Title", icon: faBlog, component: JobTitleListing,
  children: [{ path: file_ten_path + "/careerjob_title/add", component: JobTitleAdd }],
};
let jobidRoutes = { path: file_ten_path + "/careerjob_id/listing", name: "Job ID", icon: faBlog, component: JobIDListing, children: null };
const jobidRoutes1 = {
  path: file_ten_path + "/careerjob_id/listing", name: "Job ID", icon: faBlog, component: JobIDListing,
  children: [{ path: file_ten_path + "/careerjob_id/add", component: JobIDAdd }],
};
let annoucementRoutes = { path: file_ten_path + "/settingsannoucement_type/listing", name: "Announcement Type", icon: faBlog, component: AnnoucementTypeListing, children: null };
const annoucementRoutes1 = {
  path: file_ten_path + "/settingsannoucement_type/listing", name: "Announcement Type", icon: faBlog, component: AnnoucementTypeListing,
  children: [{ path: file_ten_path + "/settingsannoucement_type/add", component: AnnoucementTypeAdd }],
};
const allowncetypeRoutes1 = {
  path: file_ten_path + "/settingsallownce_type/listing", name: "Settlement Type", icon: faBlog, component: ALLoListing,
  children: [{ path: file_ten_path + "/settingsallownce_type/add", component: ALLoAdd }],
};

let allowncecodeRoutes = (login_type == "hr_admin" || (login_type == "sub_admin" && eallowancecode == "1"))
  ? { path: file_ten_path + "/settingsallownce_code/listing", name: "Settlement Code", icon: faBlog, component: ALLCoListing, children: null }
  : { path: "x" };
const allowncecodeRoutes1 = {
  path: file_ten_path + "/settingsallownce_code/listing", name: "Settlement Code", icon: faBlog, component: ALLCoListing,
  children: [{ path: file_ten_path + "/settingsallownce_code/add", component: ALLCoAdd }],
};

let noteRoutes = (login_type == "hr_admin" || (login_type == "sub_admin" && enotecode == "1"))
  ? { path: file_ten_path + "/settingsnote_code/listing", name: "Note Code", icon: faBlog, component: NoteListing, children: null }
  : { path: "x" };
const noteRoutes1 = {
  path: file_ten_path + "/settingsnote_code/listing", name: "Note Code", icon: faBlog, component: NoteListing,
  children: [{ path: file_ten_path + "/settingsnote_code/add", component: NoteAdd }],
};

const assetsRoutes1 = {
  path: file_ten_path + "/settingsassets/listing", name: "Assets", icon: faBlog, component: AssListing,
  children: [{ path: file_ten_path + "/settingsassets/add", component: AssAdd }],
};
const rolesRoutes1 = {
  path: file_ten_path + "/roles/listing", name: localStorage.getItem("95"), icon: faBlog, component: rolesListing,
  children: [{ path: file_ten_path + "/roles/add", component: rolesAdd }],
};
const sarolesRoutes1 = {
  path: file_ten_path + "/settingssaroles/listing", name: "User Role", icon: faBlog, component: sarolesListing,
  children: [
    { path: file_ten_path + "/settingssaroles/add",      component: sarolesAdd      },
    { path: file_ten_path + "/settingssaroles/dListing", component: sarolesDListing },
  ],
};
const blogRoutes1 = {
  path: file_ten_path + "/blog/listing", name: "Organization Blog", icon: faBlog, component: blogsListing,
  children: [
    { path: file_ten_path + "/blog/add",        component: blogsAdd            },
    { path: file_ten_path + "/blog/comments",   component: blogsCommentListing },
    { path: file_ten_path + "/blog/addcomments",component: blogsCommentAdd     },
  ],
};

const viewRoutes1 = {
  path: "/signup", name: localStorage.getItem("96"), icon: faIdCard,
  children: [
    { path: file_ten_path + "/signup/view",    component: SView },
    { path: file_ten_path + "/signup/message", component: SMsg  },
  ],
};

let hradminRoutes;
if (admin_id == 1 || (login_type == "super_admin" && HRAdminSuper == "1")) {
  hradminRoutes = { path: file_ten_path + "/hradmin/listing", name: "Hr Admin", icon: faUserTie, component: HRListing, children: null };
} else {
  hradminRoutes = { path: "x" };
}

const hradminRoutes1 = {
  path: "/hradmin", name: "Hr Admin", icon: faUserCircle,
  children: [{ path: file_ten_path + "/hradmin/add", component: HRAdd }],
};

// ─── Shifts / payroll / access / points routes ────────────────────────────────

let shiftsRoutes, schedularRoutesAdd, employecareerRoutes, payrollLineEntryRoutes,
    payrollLineEntryRoutes1, payrollRoutes, constantsRoutes, constantsRoutes1,
    paycodeRoutes1, DocsRoutes, PointsRoutes, AccessRoutes, PromotionsEmpRoutes,
    AssetsRoutes, ProductShopRoutes, TotalworkRoutes, joninfoRoutes;

constantsRoutes1 = {
  path: file_ten_path + "/settingsleave_type/listing", name: "Leave Type", icon: faUserCircle,
  children: [
    { path: file_ten_path + "/settingsleave_type/Add",     component: leaveTypeAdd      },
    { path: file_ten_path + "/settingsleave_type/dlisting",component: leaveTypeDListing },
  ],
};

// HR admin / full package
if (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security") {
  schedularRoutesAdd = { path: file_ten_path + "/shift_schedular/add", name: "Work Scheduler", icon: faClock, component: shiftSchedularAdd, children: null };
  PointsRoutes  = { path: "x" };
  AccessRoutes  = { path: "x" };
  AssetsRoutes  = { path: "x" };
  ProductShopRoutes = { path: "x" };
  TotalworkRoutes   = { path: "x" };
  joninfoRoutes = { path: file_ten_path + "/employees/jobinfo", name: "Job Info", icon: faCompressArrowsAlt, component: JobInfo, children: null };
  shiftsRoutes  = { path: file_ten_path + "/shifts", name: "Attendance", icon: faTable, children: [
    { path: file_ten_path + "/shifts/listing",                   name: "All Shifts",                     icon: faUserFriends, component: shiftListing,            children: null },
    { path: file_ten_path + "/shift_schedular/listing",          name: "Work Scheduler",                 icon: faClock,       component: shiftSchedularList,      children: null },
    { path: file_ten_path + "/shiftsattendance/listing",         name: "Attendance",                     icon: faClock,       component: AListing,                children: null },
    { path: file_ten_path + "/shiftsattendance/Closerlisting",   name: "Employee Attendance Summary",    icon: faClock,       component: Closelisting,            children: null },
    { path: file_ten_path + "/shiftsattendance/timmylisting",    name: "Timmy Present",                  icon: faClock,       component: ALTisting,               children: null },
    { path: file_ten_path + "/shiftsotrequest/listing",          name: "Employee Overtime Request",      icon: faClock,       component: OTRListing,              children: null },
    { path: file_ten_path + "/shifts/importattendance",          name: "Attendance Import",              icon: faUserFriends, component: EAttenceImport,          children: null },
    { path: file_ten_path + "/shiftsabsent/listing",             name: "Absent",                         icon: faUserSlash,   component: AbsenceListing,          children: null },
    { path: file_ten_path + "/shiftsleaves/listing",             name: "Leave",                          icon: faCalendarDay, component: LListing                                },
    { path: file_ten_path + "/shiftsleaves/Listingemp",          name: "Leave Bank",                     icon: faCalendarDay, component: ETLeaves                                },
    { path: file_ten_path + "/shift_schedular/listinghistory",   name: "Work Scheduler History",         icon: faClock,       component: shiftSchedularListHistory,children: null},
    { path: file_ten_path + "/shift_schedular/Importschedular",  name: "Work Scheduler Import",          icon: faClock,       component: shiftSchedularImport,    children: null },
  ]};
  payrollRoutes = { path: file_ten_path + "/payroll", name: "Payroll", icon: faMoneyBill, children: [
    { path: file_ten_path + "/payroll_line_entry/listing",          name: "Payroll Process",        icon: faFileAlt, component: payrollLineEntryList,    children: null },
    { path: file_ten_path + "/payrollpayslip/listing",              name: "Open Payslips",          icon: faFileAlt, component: payslipList,             children: null },
    { path: file_ten_path + "/payrollpayslip/listingclose",         name: "Close Payslips",         icon: faFileAlt, component: payslipListClose,        children: null },
    { path: file_ten_path + "/payrollpayslip/listingclosnotiepay",  name: "Notice Pay Payslips",    icon: faFileAlt, component: NoticepayslipListClose,  children: null },
    { path: file_ten_path + "/payrollpaycode/listing",              name: "Pay Codes",              icon: faTable,   component: PAListing,               children: null },
    { path: file_ten_path + "/payrollpayroll_line_entry/taxlisting",name: "Tax Code",               icon: faBlog,    component: TaxListing,              children: null },
    { path: file_ten_path + "/payrolltax_brackets/listing",         name: "Tax Slabs",              icon: faTable,   component: taxBracketListing,       children: null },
  ]};
} else if (login_type == "emp" && pro_package != 0 && login_type != "sub_admin" && is_timmy_machine == "0") {
  shiftsRoutes = { path: file_ten_path + "/shift_schedular/listing", name: "My Work Schedule", icon: faClock, component: shiftSchedularList, children: null };
  schedularRoutesAdd = { path: "x" };
  payrollRoutes = { path: file_ten_path + "/payrollpayslip/listing", name: "My Payslips", icon: faFileAlt, component: payslipList, children: [
    { path: file_ten_path + "/payrollpayslip/listing",      name: "Open Payslips",  icon: faFileAlt, component: payslipList,     children: null },
    { path: file_ten_path + "/payrollpayslip/listingclose", name: "Close Payslips", icon: faFileAlt, component: payslipListClose, children: null },
  ]};
  AccessRoutes  = { path: file_ten_path + "/employees/Acesscode",     name: "Acess Code",       icon: faCompressArrowsAlt, component: Acesscode,       children: null };
  PointsRoutes  = { path: file_ten_path + "/employees/ListingPoints",  name: "My Points",        icon: faTrophy,            component: EListingPoints,  children: null };
  AssetsRoutes  = { path: file_ten_path + "/employees/ListingAssts",   name: "My Assests",       icon: faTv,                component: EListingAssts,   children: null };
  TotalworkRoutes= { path: file_ten_path + "/attendance/checkinout",    name: "Check In Out",     icon: faMapMarkerAlt,      component: BView,           children: null };
  joninfoRoutes = { path: "x" };
} else if (login_type == "emp" && pro_package != 0 && login_type != "sub_admin" && is_timmy_machine == "1") {
  shiftsRoutes = { path: file_ten_path + "/shift_schedular/listing", name: "My Work Schedule", icon: faClock, component: shiftSchedularList, children: null };
  schedularRoutesAdd = { path: "x" };
  payrollRoutes  = { path: file_ten_path + "/payrollpayslip/listing", name: "My Payslips", icon: faFileAlt, component: payslipList, children: null };
  AccessRoutes   = { path: "x" };
  PointsRoutes   = { path: "x" };
  AssetsRoutes   = { path: "x" };
  TotalworkRoutes= { path: "x" };
  joninfoRoutes  = { path: "x" };
} else if (login_type == "hr_admin" && pro_package == 0) {
  shiftsRoutes = { path: file_ten_path + "/shifts", name: "Attendance", icon: faTable, children: [
    { path: file_ten_path + "/shifts/listing",              name: "All Shifts",                icon: faUserFriends, component: shiftListing,    children: null },
    { path: file_ten_path + "/shift_schedular/listing",     name: "Work Scheduler",            icon: faClock,       component: shiftSchedularList, children: null },
    { path: file_ten_path + "/shiftsattendance/listing",    name: "Attendance",                icon: faClock,       component: AListing,        children: null },
    { path: file_ten_path + "/shiftsotrequest/listing",     name: "Employee Overtime Request", icon: faClock,       component: OTRListing,      children: null },
    { path: file_ten_path + "/shiftsabsent/listing",        name: "Absent",                    icon: faUserSlash,   component: AbsenceListing,  children: null },
    { path: file_ten_path + "/shiftsleaves/listing",        name: "Leave",                     icon: faCalendarDay, component: LListing         },
    { path: file_ten_path + "/shiftsleaves/Listingemp",     name: "Leave Bank",                icon: faCalendarDay, component: ETLeaves          },
  ]};
  schedularRoutesAdd = { path: "x" };
  payrollRoutes = { path: "x" };
  AccessRoutes  = { path: "x" };
  PointsRoutes  = { path: "x" };
  AssetsRoutes  = { path: "x" };
  TotalworkRoutes = { path: "x" };
  joninfoRoutes = { path: "x" };
} else {
  shiftsRoutes       = { path: "x" };
  schedularRoutesAdd = { path: "x" };
  payrollRoutes      = { path: "x" };
  payrollLineEntryRoutes  = { path: "x" };
  payrollLineEntryRoutes1 = { path: "x" };
  constantsRoutes    = { path: "x" };
  paycodeRoutes1     = { path: "x" };
  joninfoRoutes      = { path: "x" };
  DocsRoutes         = { path: "x" };
  PointsRoutes       = { path: "x" };
  AccessRoutes       = { path: "x" };
  PromotionsEmpRoutes= { path: "x" };
  AssetsRoutes       = { path: "x" };
  TotalworkRoutes    = { path: "x" };
}

ProductShopRoutes = (login_type == "emp" && pro_package != 0 && login_type != "sub_admin" && hr_emp_shop == "true")
  ? { path: file_ten_path + "/product/shop", name: "Shop", icon: faCartPlus, component: ProductShop, children: null }
  : { path: "x" };

PromotionsEmpRoutes = (login_type == "emp" && pro_package != 0 && login_type != "sub_admin" && hr_emp_promotions == "true")
  ? { path: file_ten_path + "/employees/morepromotions", name: "Business Promotions", icon: faImages, component: EListingPromotions, children: null }
  : { path: "x" };

// Sub-admin shifts
var shiftsRoutesSub = [];
if (login_type == "sub_admin") {
  if (eshift      == "1") shiftsRoutesSub.push({ path: file_ten_path + "/shifts/listing",                name: "All Shifts",              icon: faUserFriends, component: shiftListing,             children: null });
  if (ep          == "1") shiftsRoutesSub.push({ path: file_ten_path + "/shiftsattendance/listing",      name: "Attendance",              icon: faClock,       component: AListing,                 children: null });
  if (escheduler  == "1") shiftsRoutesSub.push({ path: file_ten_path + "/shift_schedular/listing",       name: "Work Scheduler",          icon: faClock,       component: shiftSchedularList,       children: null });
  if (ea          == "1") shiftsRoutesSub.push({ path: file_ten_path + "/absent/listing",                name: "Absent",                  icon: faUserSlash,   component: AbsenceListing,           children: null });
  if (eshiftreport== "1") shiftsRoutesSub.push({ path: file_ten_path + "/shift_schedular/listing",       name: "Work Scheduler",          icon: faClock,       component: shiftSchedularList,       children: null });
  if (eleave      == "1") shiftsRoutesSub.push({ path: file_ten_path + "/shiftsleaves/listing",          name: "Leave",                   icon: faCalendarDay, component: LListing });
  if (schhistory  == "1") shiftsRoutesSub.push({ path: file_ten_path + "/shift_schedular/listinghistory",name: "Work Scheduler History",  icon: faClock,       component: shiftSchedularListHistory,children: null });

  if (shiftsRoutesSub.length > 0) {
    shiftsRoutes = { path: file_ten_path + "/pages", name: "Attendance", icon: faTable, children: shiftsRoutesSub };
  } else {
    shiftsRoutes = { path: "x" };
  }
}

// Sub-admin career
var arrayemployeecaroutes = [];
if (login_type == "sub_admin") {
  if (ejobpost == "1") arrayemployeecaroutes.push({ path: file_ten_path + "/careerjobpost/listing",       name: "Job Post",         icon: faUserFriends, component: JobpostListing,  children: null });
  if (eapplist == "1") arrayemployeecaroutes.push({ path: file_ten_path + "/careerjobpost/Applicantlisting",name: "Application List",icon: faUserFriends, component: Applist,         children: null });
  if (ejurl    == "1") arrayemployeecaroutes.push({ path: file_ten_path + "/careers",                     name: "Job Frontend Url", icon: faHome,        target: "_blank", component: Landing, children: null });
  if (ejd      == "1") arrayemployeecaroutes.push({ path: file_ten_path + "/careerjob_descripation/listing",name: "Job Description",icon: faBusinessTime,component: JobdescListing,  children: null });
  if (jbtype   == "1") arrayemployeecaroutes.push({ path: file_ten_path + "/careerjob_type/listing",       name: "Job Type",         icon: faBlog,        component: JobTypeListing,  children: null });

  if (hr_emp_careeer == "true" && arrayemployeecaroutes.length > 0) {
    employecareerRoutes = { path: file_ten_path + "/pages", name: "Employee Career", icon: faTable, children: arrayemployeecaroutes };
  } else {
    employecareerRoutes = { path: "x" };
  }
}

// hr_admin career
if (login_type != "sub_admin") {
  if (
    (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && hr_emp_careeer == "true") ||
    (login_type == "hr_admin" && hr_emp_careeer == "true" && pro_package == "0")
  ) {
    employecareerRoutes = { path: file_ten_path + "/career", name: "Employee Career", icon: faTable, children: [
      { path: file_ten_path + "/careerjobdisclouser",                  name: "Job Disclosure",   icon: faLandmark,     component: Jobdisc,         children: null },
      { path: file_ten_path + "/careerjob_descripation/listing",       name: "Job Description",  icon: faBusinessTime, component: JobdescListing,  children: null },
      { path: file_ten_path + "/careerjob_type/listing",               name: "Job Type",         icon: faBlog,         component: JobTypeListing,  children: null },
      { path: file_ten_path + "/carrerjob_title/listing",              name: "Job Title",        icon: faBlog,         component: JobTitleListing, children: null },
      { path: file_ten_path + "/careerjob_id/listing",                 name: "Job ID",           icon: faBlog,         component: JobIDListing,    children: null },
      { path: file_ten_path + "/careerjobpost/listing",                name: "Job Post",         icon: faUserFriends,  component: JobpostListing,  children: null },
      { path: file_ten_path + "/careerjobpost/Applicantlisting",       name: "Application List", icon: faUserFriends,  component: Applist,         children: null },
      { path: file_ten_path + "/careers",                              name: "Job Frontend Url", icon: faHome, target: "_blank", component: Landing, children: null },
    ]};
  } else if (login_type != "emp") {
    employecareerRoutes = { path: "x" };
  }
  if (login_type == "emp") {
    employecareerRoutes = { path: "x" };
  }
}

// Sub-admin payroll
var arraypayroll = [];
if (login_type == "sub_admin") {
  if (ebracket == "1") arraypayroll.push({ path: file_ten_path + "/payrolltax_brackets/listing",  name: "Tax Slabs",       icon: faTable,   component: taxBracketListing,     children: null });
  if (epayroll == "1") arraypayroll.push({ path: file_ten_path + "/payroll_line_entry/listing",   name: "Payroll Process", icon: faFileAlt, component: payrollLineEntryList,  children: null });
  if (epayslip == "1") arraypayroll.push(
    { path: file_ten_path + "/payrollpayslip/listing",      name: "Open Payslips",  icon: faFileAlt, component: payslipList,      children: null },
    { path: file_ten_path + "/payrollpayslip/listingclose", name: "Close Payslips", icon: faFileAlt, component: payslipListClose, children: null }
  );
  if (epaycode == "1") arraypayroll.push({ path: file_ten_path + "/payrollpaycode/listing",       name: "Pay Codes",       icon: faTable,   component: PAListing,             children: null });

  payrollRoutes = (arraypayroll.length > 0)
    ? { path: file_ten_path + "/pages", name: "Payroll", icon: faMoneyBill, children: arraypayroll }
    : { path: "x" };
}

DocsRoutes = (login_type == "emp" && pro_package != 0 && is_timmy_machine == "0")
  ? { path: file_ten_path + "/employees/ListingDocs", name: "My Documents", icon: faPrint, component: EListingDocs, children: null }
  : { path: "x" };

payrollLineEntryRoutes1 = {
  path: file_ten_path + "/payroll_line_entry/listing", name: "Payroll Process", icon: faUserCircle,
  children: [
    { path: file_ten_path + "/hradminpayroll_line_entry/add",           component: payrollLineEnrtyAdd          },
    { path: file_ten_path + "/payroll_line_entry/import_payslip_data",  component: payslipImport                },
    { path: file_ten_path + "/payroll_line_entry/data",                 component: payslipImportExportBefore    },
    { path: file_ten_path + "/payroll_line_entry/datanp",               component: payslipImportExportBeforeNp },
    { path: file_ten_path + "/payroll_line_entry/report",               component: payrollreport               },
    { path: file_ten_path + "/payroll_line_entry/listingtest",          component: payrollLineEntryListTest     },
    { path: file_ten_path + "/payslip/Payslip_pdf/:id",                 component: payslippdf                  },
    { path: file_ten_path + "/payslip/View_payslip/:id/:id2",           component: viewPayslip                 },
    { path: file_ten_path + "/payroll_line_entry/allreports",           component: allPayrollreport            },
  ],
};

paycodeRoutes1 = {
  path: file_ten_path + "/paycode/listing", name: "Pay Codes", icon: faUserCircle,
  children: [{ path: file_ten_path + "/paycode/Add", component: PAAdd }],
};

let superadminStaffRoutes = ((admin_id == 1 && login_id == 1) || (login_type == "super_admin" && admin_id == 1 && AdminStaffSuper == "1"))
  ? { path: file_ten_path + "/superadmin_staff/listing", name: "Super User", icon: faUserFriends, component: superadminStaffListing, children: null }
  : { path: "x" };

let adminStaffRoutes;
if (isHrAdmin && pro_package != 0) {
  adminStaffRoutes = { path: file_ten_path + "/admin_staff", name: TF("{0}", T("Staff")), icon: faUserFriends, children: [
    { path: file_ten_path + "/employeesadmin_staff/listing",          name: TF("{0}", T("Sub Admin")), icon: faUserFriends, component: adminStaffListing,    children: null },
    { path: file_ten_path + "/employyesadmin_staff/listingsecurity",  name: TF("{0}", T("Security")),  icon: faUserFriends, component: securityStaffListing, children: null },
  ]};
} else if (login_type == "sub_admin" && esubadmin == "1" && esec == "1") {
  adminStaffRoutes = { path: file_ten_path + "/admin_staff", name: TF("{0}", T("Staff")), icon: faUserFriends, children: [
    { path: file_ten_path + "/employeesadmin_staff/listing",         name: TF("{0}", T("Sub Admin")), icon: faUserFriends, component: adminStaffListing,    children: null },
    { path: file_ten_path + "/employeesadmin_staff/listingsecurity", name: TF("{0}", T("Security")),  icon: faUserFriends, component: securityStaffListing, children: null },
  ]};
} else if (login_type == "sub_admin" && esubadmin == "1") {
  adminStaffRoutes = { path: file_ten_path + "/admin_staff", name: TF("{0}", T("Staff")), icon: faUserFriends, children: [
    { path: file_ten_path + "/employeesadmin_staff/listing", name: TF("{0}", T("Sub Admin")), icon: faUserFriends, component: adminStaffListing, children: null },
  ]};
} else if (login_type == "sub_admin" && esec == "1") {
  adminStaffRoutes = { path: file_ten_path + "/admin_staff", name: TF("{0}", T("Staff")), icon: faUserFriends, children: [
    { path: file_ten_path + "/employeesadmin_staff/listingsecurity", name: TF("{0}", T("Security")), icon: faUserFriends, component: securityStaffListing, children: null },
  ]};
} else {
  adminStaffRoutes = { path: "x" };
}

const adminStaffRoutes1 = {
  path: file_ten_path + "/employeesadmin_staff/listing", name: "Admin Staff", icon: faUserFriends, component: adminStaffListing,
  children: [
    { path: file_ten_path + "/employeesadmin_staff/Add",           component: adminStaffAdd    },
    { path: file_ten_path + "/employeesadmin_staff/AddSecurity",   component: securityStaffAdd },
  ],
};

const superadminStaffRoutes1 = {
  path: file_ten_path + "/superadmin_staff/listing", name: "Super User", icon: faUserFriends, component: superadminStaffListing,
  children: [{ path: file_ten_path + "/superadmin_staff/Add", component: superadminStaffAdd }],
};

let IssueRoutes1 = {
  path: file_ten_path + "/employeesissues/listing", name: "Employee Issue", icon: faUserFriends, component: IssueListing,
  children: [{ path: file_ten_path + "/employeesissues/Add", component: IssueAdd }],
};

const employeeActivityLogRoutes1 = {
  path: file_ten_path + "/employeesactivity/listing", name: "Employee Log Activity", icon: faUserFriends, component: ATLListing,
  children: [{ path: file_ten_path + "/employeesactivity/Add", component: ATLAdd }],
};
const employeeActivitysetRoutes1 = {
  path: file_ten_path + "/employeestaregetactvity/listing", name: "Employee Monthaly Target", icon: faUserFriends, component: EASListing,
  children: [
    { path: file_ten_path + "/employeestaregetactvity/Add", component: EASAdd  },
    { path: file_ten_path + "/employeestaregetactvity/kpi", component: EASKPI  },
  ],
};
const employeeActivitysetSummaryRoutes1 = {
  path: file_ten_path + "/employeestaregetsummaryactvity/listing", name: "Employee Summary Target Activity", icon: faUserFriends, component: EASummaryListing,
  children: [{ path: file_ten_path + "/employeestaregetsummaryactvity/Add", component: EASummaryAdd }],
};
const employeeOTRequestRoutes1 = {
  path: file_ten_path + "/shiftsotrequest/listing", name: "Employee Overtime Request", icon: faUserFriends, component: OTRListing,
  children: [
    { path: file_ten_path + "/shiftsotrequest/Add",      component: OTRAdd     },
    { path: file_ten_path + "/shiftsotrequest/dlisting", component: OTRDListing, children: null },
  ],
};

const shiftsRoutes1 = {
  path: file_ten_path + "/shifts/listing", name: "Attendance", icon: faTable, component: shiftListing,
  children: [
    { path: file_ten_path + "/shifts/add",             component: shiftAdd          },
    { path: file_ten_path + "/shift_schedular/add",    component: shiftSchedularAdd },
  ],
};

let taxBracketRoutes = (admin_id != 1 && login_type != "super_admin" && pro_package != 0)
  ? { path: file_ten_path + "/tax_brackets/listing", name: "Manage Tax Slabs", icon: faTable, component: taxBracketListing, children: null }
  : { path: "x" };
const taxBracketRoutes1 = {
  path: file_ten_path + "/tax_brackets/listing", name: "Manage Tax Slabs", icon: faList, component: taxBracketListing,
  children: [{ path: file_ten_path + "/tax_brackets/add", component: taxBracketAdd }],
};

// HR Admin payroll
let payrollHradminRoutes;
if (login_type == "hr_admin" && pro_package != "0") {
  payrollHradminRoutes = { path: file_ten_path + "/hradmin", name: "HR Admin Payroll Processes", icon: faTable, children: [
    { path: file_ten_path + "/hradmin/addlisting",    name: "Payroll Line Entry Record",     icon: faUserFriends, component: payrollLineEntryListAdd,    children: null },
    { path: file_ten_path + "/hradmin/closelisting",  name: "Closed Payroll Line Entry",     icon: faUserFriends, component: payrollLineEntryListAddClose, children: null},
    { path: file_ten_path + "/hradmin/cancellisting", name: "Cancelled Payroll Line Entry",  icon: faUserFriends, component: payrollLineEntryListAddCancel,children: null},
  ]};
} else if (paylineprivilage == "1") {
  payrollHradminRoutes = { path: file_ten_path + "/hradmin", name: "HR Admin Payroll Processes", icon: faTable, children: [
    { path: file_ten_path + "/hradmin/addlisting",    name: "Payroll Line Entry Record",     icon: faUserFriends, component: payrollLineEntryListAdd,    children: null },
    { path: file_ten_path + "/hradmin/closelisting",  name: "Closed Payroll Line Entry",     icon: faUserFriends, component: payrollLineEntryListAddClose, children: null},
    { path: file_ten_path + "/hradmin/cancellisting", name: "Cancelled Payroll Line Entry",  icon: faUserFriends, component: payrollLineEntryListAddCancel,children: null},
  ]};
} else {
  payrollHradminRoutes = { path: "x" };
}

// Employee shop (sub-admin uses permission flags to build children dynamically)
let employeshopRoutes;
{
  const _shop = hr_emp_shop == "true";
  const _cat  = eprocat == "1", _pro = epro == "1", _ord = eorder == "1", _ban = ebanner == "1";
  const shopChildren = [];
  if (_cat) shopChildren.push({ path: file_ten_path + "/shopsproductcategory/listing", name: "Product Category", icon: faUserFriends, component: ProductcatgoryListing, children: null });
  if (_pro) shopChildren.push({ path: file_ten_path + "/shopsproduct/listing",         name: "Products",         icon: faVolumeUp,    component: ProductListing,        children: null });
  if (_ord) shopChildren.push({ path: file_ten_path + "/shopsorder/listing",           name: "Orders",           icon: faTruck,       component: OrderListing,          children: null });
  if (_ban) {
    bannerRoutes = { path: file_ten_path + "/shopsbanner/listing", name: "Banner", icon: faImages, component: BAListing, children: null };
    shopChildren.push(bannerRoutes);
  }

  if (login_type == "sub_admin" && _shop && shopChildren.length > 0) {
    employeshopRoutes = { path: file_ten_path + "/shops", name: "Employee Shop", icon: faTable, children: shopChildren };
  } else if (
    (admin_id != 1 && login_type != "super_admin" && pro_package != 0 && login_type != "emp" && login_type != "security" && login_type != "sub_admin" && _shop) ||
    (login_type == "hr_admin" && _shop && pro_package == "0")
  ) {
    employeshopRoutes = { path: file_ten_path + "/shops", name: "Employee Shop", icon: faTable, children: [
      { path: file_ten_path + "/shopsproductcategory/listing", name: "Product Category", icon: faUserFriends, component: ProductcatgoryListing, children: null },
      { path: file_ten_path + "/shopsproduct/listing",         name: "Products",         icon: faVolumeUp,    component: ProductListing,        children: null },
      { path: file_ten_path + "/shopsorder/listing",           name: "Orders",           icon: faTruck,       component: OrderListing,          children: null },
      (bannerRoutes = { path: file_ten_path + "/shopsbanner/listing", name: "Banner", icon: faImages, component: BAListing, children: null }),
    ]};
  } else if (login_type == "emp" && pro_package != 0 && _shop) {
    employeshopRoutes = { path: file_ten_path + "/shopsorder/listing", name: "My Orders", icon: faTruck, component: OrderListing, children: null };
  } else {
    employeshopRoutes = { path: "x" };
  }
}

const employeshopRoutes1 = {
  path: file_ten_path + "/shopsproductcategory/listing", name: "Product Category", icon: faTable, component: ProductcatgoryListing,
  children: [
    { path: file_ten_path + "/shopsproductcategory/add",    component: ProductcatgoryAdd },
    { path: file_ten_path + "/shopsproduct/add",            component: ProductAdd        },
    { path: file_ten_path + "/shopsorder/add",              component: OrderAdd          },
    { path: file_ten_path + "/shopsproduct/shopproducts",   component: CardAdd           },
    { path: file_ten_path + "/shopsproduct/shoptopproducts",component: TopproductAdd     },
    { path: file_ten_path + "/shopsproduct/cartinfo",       component: CartAdd           },
    { path: file_ten_path + "/shopsproduct/moreinfo",       component: ShopAdd           },
    { path: file_ten_path + "/shopsbanner/add/:id/:id1",    component: BAAdd             },
  ],
};

const pointsRoutes  = { path: file_ten_path + "/settingspoints/listing", name: "Point Declaration", icon: faTrophy, component: PublicPointListing, children: null };
const pointsRoutes1 = {
  path: "/settingspoints/listing", name: "Point Declaration", icon: faVolumeUp, component: PublicPointListing,
  children: [
    { path: file_ten_path + "/settingspoints/add",     component: PublicPointAdd          },
    { path: file_ten_path + "/settingspoints/dlisting",component: PublicPointDeleteListing},
  ],
};

const JDRoutes  = { path: file_ten_path + "/careerjob_descripation/listing", name: "Job Description", icon: faBusinessTime, component: JobdescListing, children: null };
const JDRoutes1 = {
  path: file_ten_path + "/careerjob_descripation/listing", name: "Job Description", icon: faBusinessTime, component: JobdescListing,
  children: [
    { path: file_ten_path + "/careerjob_descripation/add",  component: JobdescAdd  },
    { path: file_ten_path + "/careerjob_descripation/info", component: JobdescCard },
  ],
};

const employecareerRoutes1 = {
  path: file_ten_path + "/careerjobpost/listing", name: "Job Post", icon: faTable, component: JobpostListing,
  children: [
    { path: file_ten_path + "/careerjobpost/add",               component: JobpostAdd },
    { path: file_ten_path + "/careerjobpost/JobpostAppListing", name: "Application List", icon: faUserFriends, component: JApplist, children: null },
  ],
};

const otrequest = {
  path: file_ten_path + "/shiftsotrequest/listing", name: "Employee Overtime Request", icon: faClock, component: OTRListing, children: null,
};

const PromotionsRoutes1 = {
  path: file_ten_path + "/promotions/listing", name: "Employee Promotions", icon: faImages, component: PListing,
  children: [{ path: file_ten_path + "/promotions/add", component: PAdd }],
};

const PointsRoutes1 = {
  path: file_ten_path + "/settingspoints/listing", name: "Points", icon: faTrophy, component: PublicPointListing,
  children: [{ path: file_ten_path + "/settingspoints/add", component: PublicPointAdd }],
};

const DocsRoutes1 = {
  path: file_ten_path + "/employees/ListingDocs", name: "My Documents", icon: faPrint, component: EListingDocs,
  children: [],
};

const AssetsRoutes1 = {
  path: file_ten_path + "/employees/ListingAssts", name: "My Assets", icon: faTv, component: EListingAssts,
  children: [],
};

const ProductShopRoutes1 = {
  path: file_ten_path + "/product/shop", name: "Shop", icon: faCartPlus, component: ProductShop, children: null,
};

const TotalworkRoutes1 = {
  path: file_ten_path + "/attendance/checkinout", name: "Check In Out", icon: faMapMarkerAlt, component: BView, children: null,
};

let AiAgentRoutes = {
  path: file_ten_path + "/ai-agent",
  name: "Workflow Agent",
  icon: faCommentAlt,
  component: AiAgent,
  children: null,
};


let HRAiAgentRoutes = {
  path: file_ten_path + "/ai-agent-hr",
  name: "HR Agent",
  icon: faCommentAlt,
  component: RouteAiAgent,
  children: null,
};

// ─── custom == "1": disable all routes ───────────────────────────────────────

if (localStorage.getItem("custom") == "1") {
  dashboardRoutes = shiftsRoutes = payrollRoutes = reportRoutes = workplanroutes =
  employeeEvalutionReport = employecareerRoutes = employetrainingRoutes = MsgRoutes =
  employeshopRoutes = ProductShopRoutes = promotionRoutes = PromotionsEmpRoutes =
  announcementRoutes = blogRoutes = HrblogRoutes = HrletterRoutes = guestRoutes =
  SettingRoutes = attendanceRoutes = leaveRoutes = AccessRoutes = signupRoutes =
  hradminRoutes = ComplaintRoutes = PointsRoutes = payrollHradminRoutes =
  SettingRoutesEmp = DocsRoutes = AssetsRoutes = empcheckinoutRoutes =
  incidentRoutes = groupsRoutes = superadminStaffRoutes = empRoutes = logs = profile = AiAgentRoutes =HRAiAgentRoutes =
    { path: "x" };
}

// ─── Remaining route vars needed for exports ─────────────────────────────────

if (!empRoutes)           empRoutes           = { path: "x" };
if (!landingRoutesNewCompanyEmp) landingRoutesNewCompanyEmp = { path: "x" };
if (!profile)             profile             = { path: "x" };
if (!logs)                logs                = { path: "x" };

// ─── Exports ─────────────────────────────────────────────────────────────────

export const dashboard = [
  ottypeRoutes, otRoutes1, Mytaxcode1, Mytaxtable1, otrequest,
  AttendancevaluationRoutes1, leaveBankRoutes, epftypeRoutes, epfRoutes1,
  soctypeRoutes, socRoutes1, eisRoutes1, eistypeRoutes,
  employeeActivityLogRoutes1, employeeActivitysetRoutes1, employeeActivitysetSummaryRoutes1,
  dashboardRoutes, SignCustomRoutes,
  ActivityTypeRoutes1, ActivityStatusRoutes1, ActivityvaluationRoutes1,
  HrFieldRoutes1, SettingRoutes, employeeEvalutionReport,
  MYprofile1, jobdisRoutes, signupRoutes, viewRoutes1,
  hradminRoutes1, hradminRoutes,
  empRoutes, empRoutes1,
  orgRoutes, orgRoutes1, orgRoutesSeries1,
  leaveRoutes, leaveRoutes1,
  announcementRoutes, announcementRoutes1,
  attendanceRoutes, attendanceRoutes1,
  promotionRoutes, promotionRoutes1,
  logs, holidayRoutes, holidayRoutes1,
  empGroupRoutes, empGroupRoutes1,
  complaintsRoutes, complaintsRoutes1,
  allowncetypeRoutes, coursetypeRoutes, coursetypeRoutes1,
  payrollroutes1, payrollroutes, taxRoutes1,
  categorytypeRoutes, categorytypeRoutes1,
  jobidRoutes, jobidRoutes1,
  employeeOTRequestRoutes1, complainttypeRoutes, complainttypeRoutes1,
  blogtypeRoutes, blogtypeRoutes1,
  jobtypeRoutes, jobtypeRoutes1,
  jobtitleRoutes, jobtitleRoutes1,
  annoucementRoutes, annoucementRoutes1,
  allowncetypeRoutes1,
  noteRoutes, noteRoutes1,
  PayrollPrivilegeRoutes, PayrollPrivilegeRoutes1,
  empPayrollNoteBulkRoutes, leaveBankRoutes,
  empBulkRoutes, absentRoutes, absentRoutes1,
  shiftsRoutes, shiftsRoutes1,
  taxBracketRoutes, taxBracketRoutes1,
  schedularRoutesAdd, empSettlementBulkRoutes,
  payrollHeadersRoutes, payrollHeadersRoutes1,
  NoticePayCheckRoutes, NoticePayCheckRoutes1,
  payrollLineEntryRoutes1, payrollRoutes,
  DepartmentRoutes, DepartmentRoutes1,
  adminStaffRoutes, adminStaffRoutes1,
  superadminStaffRoutes, superadminStaffRoutes1,
  employeshopRoutes, employeshopRoutes1,
  pointsRoutes1, pointsRoutes,
  AccessRoutes, PromotionsEmpRoutes,
  joninfoRoutes, constantsRoutes1,
  JDRoutes, JDRoutes1,
  employecareerRoutes, employecareerRoutes1,
  empSettlementBulkRoutesAll,
  incidentRoutes1, holidayBulkRoutes,
  allowncecodeRoutes, allowncecodeRoutes1,
  incidentRoutes, assetsRoutes, assetsRoutes1,
  empcheckinoutRoutes, sarolesRoutes1, sarolesRoutes,
  MsgRoutes, paycodeRoutes1, profile,
  ComplaintRoutes,
  employetrainingRoutes, employetrainingRoutes1,
  blogRoutes, blogRoutes1, documenttypeRoutes, documenttypeRoutes1,
  HrblogRoutes, adminappRoutes, adminappRoutes1,
  categoryRoutes, categoryRoutes1,
  subCategoryRoutes, subCategoryRoutes1,
  orgGroupsRoutes, orgGroupsRoutes1,
  reportRoutes, TicketcategoryRoutes1,
  bannerRoutes, bannerRoutes1,
  BankRoutes, BankRoutes1,
  DocsRoutes, PointsRoutes, AssetsRoutes, ProductShopRoutes, TotalworkRoutes,
  AiAgentRoutes,HRAiAgentRoutes,
  rolesRoutes, rolesRoutes1,
  guestRoutes, guestRoutes1,
  landingRoutes, workpjectroutes1, IssueRoutes1,
  workplanroutes, workreport1,
  payrollHradminRoutes, workpjectroutestasks1, workpjectroutestasks,
  HrletterRoutes, HrletterRoutes1,
  groupsRoutes, groupsRoutes1,
];

// Landing specific routes
export const landing = [landingRoutesNew, landingRoutesNewCompany];

// Auth specific routes
export const page = [landingRoutesNew, landingRoutesNewCompany];

// All routes
export default [
  dashboardRoutes, SignCustomRoutes, TotalworkRoutes,
  empRoutes, shiftsRoutes, otrequest, payrollRoutes, reportRoutes,
  workplanroutes, employeeEvalutionReport,
  employecareerRoutes, employetrainingRoutes,
  MsgRoutes, employeshopRoutes, ProductShopRoutes,
  promotionRoutes, PromotionsEmpRoutes,
  announcementRoutes, blogRoutes, HrblogRoutes, HrletterRoutes,
  guestRoutes, SettingRoutes, attendanceRoutes, leaveRoutes,
  AccessRoutes, signupRoutes, hradminRoutes,
  ComplaintRoutes, PointsRoutes, payrollHradminRoutes, SettingRoutesEmp,
  DocsRoutes, AssetsRoutes, empcheckinoutRoutes, incidentRoutes, groupsRoutes,
  superadminStaffRoutes, landingRoutesNewCompanyEmp, profile, logs, AiAgentRoutes,HRAiAgentRoutes,
];
